// const stage = window.location.origin.includes("dev.aawz.com.br") ? 'dev' : 'prod'

/**
 * Override explícito da URL da API, injetado no build (`VUE_APP_API_BASE_URL`).
 *
 * Existe para o caso "app do repo × API de outro ambiente": o E2E em CI
 * (`PW_ENV=ci`) sobe ESTE código em localhost:8080 e precisa falar com a API do
 * ambiente de dev (whitelabelh), em vez do `dev.aawz.com.br` que a escolha por
 * NODE_ENV entregaria. É o mesmo truque do QA manual ("baseURL hijack"), só que
 * versionado em vez de patch local não comitado.
 *
 * Quando a variável não está definida, o valor é string vazia e TODO o
 * comportamento de resolução por NODE_ENV/VUE_APP_HOMOLOG/VUE_APP_TEST_ENV
 * permanece exatamente como antes.
 */
const apiBaseUrlOverride = process.env.VUE_APP_API_BASE_URL || ''

// Configurações
const baseURL = {
  local: 'http://localhost:5000',
  local_whitelabel: 'http://whitelabelh.aawz.local.com.br:5000',
  dev: 'https://dev.aawz.com.br',
  test: 'https://httpbin.org',
  prod: 'https://portal.aawz.com.br',
  homolog:
    'http://aawz-server-homolog.jp3bzqiyxh.us-east-2.elasticbeanstalk.com',
}

const images = {
  news: {
    'bg-bloomberg':
      'https://aawz-public.s3.us-east-2.amazonaws.com/images/noticias/Bloomberg-bg.jpeg',
    'bg-estadao':
      'https://aawz-public.s3.us-east-2.amazonaws.com/images/noticias/Estadao-bg.jpeg',
    'bg-valorinveste':
      'https://aawz-public.s3.us-east-2.amazonaws.com/images/noticias/valorinveste-bg.jpeg',
    'bg-valor':
      'https://aawz-public.s3.us-east-2.amazonaws.com/images/noticias/valor-bg.jpeg',
    Bloomberg:
      'https://aawz-public.s3.us-east-2.amazonaws.com/images/noticias/Bloomberg.png',
    'Bloomberg Brasil':
      'https://aawz-public.s3.us-east-2.amazonaws.com/images/noticias/Bloomberg.png',
    'Estadao.com.br':
      'https://aawz-public.s3.us-east-2.amazonaws.com/images/noticias/Estadao.com.br.png',
    Estadão:
      'https://aawz-public.s3.us-east-2.amazonaws.com/images/noticias/Estadao.com.br.png',
    'Economia Estadão':
      'https://aawz-public.s3.us-east-2.amazonaws.com/images/noticias/Estadao.com.br.png',
    'Política Estadão':
      'https://aawz-public.s3.us-east-2.amazonaws.com/images/noticias/Estadao.com.br.png',
    'Coluna do Broadcast':
      'https://aawz-public.s3.us-east-2.amazonaws.com/images/noticias/colunadobroad.png',
    'Uol.com.br':
      'https://aawz-public.s3.us-east-2.amazonaws.com/images/noticias/Uol.com.br.png',
    'Moneytimes.com.br':
      'https://aawz-public.s3.us-east-2.amazonaws.com/images/noticias/Moneytimes.com.br.png',
    // 'Terra.com.br': '',
    InfoMoney:
      'https://aawz-public.s3.us-east-2.amazonaws.com/images/noticias/InfoMoney.png',
    'Google News':
      'https://aawz-public.s3.us-east-2.amazonaws.com/images/noticias/Google+News.png',
    'Valor Econômico':
      'https://aawz-public.s3.us-east-2.amazonaws.com/images/noticias/valor.png',
    'Valor Investe':
      'https://aawz-public.s3.us-east-2.amazonaws.com/images/noticias/valorinveste.png',
    globo: {
      g1: 'https://aawz-public.s3.us-east-2.amazonaws.com/images/noticias/g1.png',
      valorinveste:
        'https://aawz-public.s3.us-east-2.amazonaws.com/images/noticias/valorinveste.png',
      valor:
        'https://aawz-public.s3.us-east-2.amazonaws.com/images/noticias/valor.png',
    },
  },
}

const dev = {
  espelho: '/mirror',
}

const navbar = {}

const zendesk = {
  bi: {
    passos:
      'https://aawz.zendesk.com/hc/pt-br/articles/4411631287191-Os-primeiros-passos-para-a-utiliza%C3%A7%C3%A3o-do-BI',
    geral:
      'https://aawz.zendesk.com/hc/pt-br/articles/4411214324503-Vis%C3%A3o-Geral-',
    partnership:
      'https://aawz.zendesk.com/hc/pt-br/articles/4411234802199-Partnership',
    carreira:
      'https://aawz.zendesk.com/hc/pt-br/articles/4411246017815-Plano-de-carreira',
    expansao:
      'https://aawz.zendesk.com/hc/pt-br/articles/4412796013847-Expans%C3%A3o-',
    financeiro:
      'https://aawz.zendesk.com/hc/pt-br/articles/4412797324439-Financeiro-',
    planilhas:
      'https://aawz.zendesk.com/hc/pt-br/articles/4411289214487-Planilhas',
    configuracoes:
      'https://aawz.zendesk.com/hc/pt-br/articles/4411314565015-Configura%C3%A7%C3%B5es-',
  },
}

const whatsApp = {
  link: (message, phone = '5548991847559') =>
    `https://api.whatsapp.com/send?text=${encodeURIComponent(
      message
    )}&phone=${phone}`,
}

const user = {
  profile: '/v2/api/general/data/self/get',
  logout: '/logout',
  tela_login: '/login',
  wirecard: 'https://connect.wirecard.com.br/',
  support: 'https://aawz.zendesk.com/hc/pt-br',
  suporte: 'https://aawz.zendesk.com/hc/pt-br',
  /**
   * @param {String} password
   * @param {String} new_password
   * @param {String} confirm_new_password
   */
  profissional: {
    change_password: '/v2/api/professional/credentials/change_password',
    perfil_to_client: '/v2/api/professional/view_switcher/switch_to_client', // GET
    /**
     * @deprecated Usar GET pagare.add_bank_account
     */
    dados_pagamento: '/v2/api/professional/receiver', // GET
  },
  client: {
    change_password: '/v2/api/client/credentials/change_password',
    perfil_to_professional:
      '/v2/api/client/view_switcher/switch_to_professional', // GET
    /**
     * @deprecated Usar GET contratarServico.add_pagarme_card
     */
    dados_pagamento: '/v2/api/client/payment', // GET
  },
}

const emails = {
  check: '/v2/api/professional/email/check_validation',
  validar: '/v2/api/professional/email/send_email_validation',
  list: '/v2/api/professional/email/list_emails', // GET
}

const utils = {
  /**
   * Rota para enviar um e-mail para gestao@aawz.com.br.
   * Com asteristicos o que aparece no e-mail enviado de fato.
   * @method POST
   * @param {String} origem *
   * @param {String} subject *[Opcional] Campo de assunto do e-mail
   * @param {String} name *[Opcional]
   * @param {String} telefone *[Opcional]
   * @param {String} email *[Opcional]
   * @param {String} empresa *[Opcional]
   * @param {String} cnpj *[Opcional]
   * @param {String} tamanho_carteira [Opcional]
   */
  contato: '/v2/api/utils/contact-us',
}

const workspace = {
  get_url: '/v2/api/professional/workspace/request_connection',
  ws_dev: 'wss://oervqne3w7.execute-api.us-east-2.amazonaws.com/dev',
  ws_prod: 'wss://oervqne3w7.execute-api.us-east-2.amazonaws.com/prod',
  ws: 'wss://oervqne3w7.execute-api.us-east-2.amazonaws.com/' + 'dev',
  /**
   * Coletar Token para usar na conexao com WS do workspace
   * token no value.token
   */
  token: '/v2/api/professional/workspace/request_connection',
  /**
   * @method GET Listar salas
   *      @return {JSON} value: lista de salas. total_unread: Qtd não lidas.
   * @method POST Criar sala
   *      @param {Boolean} is_peer_chat Conversa privada ou não
   *      @param {String} name Nome da sala
   *      @param {String} description Descrição da sala
   *      @param {Array} participants_professional_ids Lista de profissionais (Não precisa do atual)
   *      @param {Array} participants_clients_ids Lista de clientes (Não precisa do atual)
   */
  rooms: '/v2/api/professional/workspace/room',
  /**
   * @method PUT Editar sala
   * @param {String} name
   * @param {String} description
   * @param {Array} participants_professional_ids
   * @param {Array} participants_clients_ids
   */
  room_edit: '/v2/api/professional/workspace/room/', // <string:token_sala>
  /**
   * Rota para pegar as mensagem de uma sala especifica
   * @method GET
   *      @queries pagination_number: int (required) | numero da paginacao
   *           with_pagination bool | acho que nao vai ser usado
   *           messages_per_page: int | numero de mensagens por pagina (nao sei se vamos usar. Se nao passar o padrao é 100)
   * @method PUT marcar sala como lida
   */
  room_messages: '/v2/api/professional/workspace/messages/', // cd7678a5-931c-44fa-b826-69f73dd2d4dd?pagination_number=0
  /**
   * @method POST Enviar erro gerado pelo workspace para backend.
   * @param {String} source Fonte do erro. Ex: conexao com workspace.
   * @param {String} reason Motivo do erro. Opcional.
   * @param {String} message Mensagem do erro. Opcional.
   * @param {JSON} additional_info Informacoes adicionais
   */
  report_erro: '/v2/api/utils/notify-error',
}

const notificacao = {
  /**
   * Lê todas as notificações disponíveis.
   */
  read_all: '/v2/api/professional/notifications/read_all', // GET
  /**
   * Retorna lista menor de notificações, com scroll infinito.
   * @param {Integer} page Optional. Default: 1
   * @param {Integer} page_tam Optional. Default: 10
   */
  read_news: '/v2/api/professional/notifications/read_news',
  /**
   * Coleta a quantidade de notificações não lidas.
   */
  qtd_not_read: '/v2/api/professional/notifications/qtd_not_read', // GET
  /**
   * Marca uma notificação como clicada.
   * @param {Integer} id_notificacao
   */
  set_click: '/v2/api/professional/notifications/click',
  /**
   * Marca uma notificação como lida.
   * @param {Integer} id_notificacao
   */
  set_read: '/v2/api/professional/notifications/set_read',
  set_read_all: '/v2/api/professional/notifications/set_read_all',
}

/* TELAS */

const tarefasDia = {
  /**
   * Resultados das tarefas
   */
  get: '/v2/api/professional/daily_tasks/results/get',
  /**
   * Dados sobre as rotinas
   * @type {GET} Requisição
   */
  tasks: '/v2/api/professional/daily_tasks/list',
  /**
   * Profissional editar a parametrização das tarefas para ele
   * @param {Integer} id_tarefa
   * @param {Integer} id_parametrizacao_profissional Null se não tiver
   * @param {JSON} dados_parametros Verificar dados
   */
  edit_professional: '/v2/api/professional/daily_tasks/edit',
  /**
   * Gestor editar a parametrização das tarefas para o escritório
   * @param {Integer} id_tarefa
   * @param {Integer} id_parametrizacao_profissional Null se não tiver
   * @param {JSON} dados_parametros Verificar dados
   */
  edit_gestor: '/v2/api/professional/daily_tasks/office/edit',
  /**
   * Rodar novamente tarefas específicas
   * @param {List} ids_tarefas [int] das tarefas a serem executadas
   */
  run: '/v2/api/professional/daily_tasks/run/',
  /**
   * Executar algum cliente na tarefa, marcando como concluido
   * @param {Integer} id_tarefa
   * @param {List} ids [int] lista dos ids dos clientes concluidos
   */
  confirm: '/v2/api/professional/daily_tasks/execute',
}

const produtos = {
  relatorio_setorial: {
    listar: '/v2/api/relatorio-setorial/subscribed/list',
  },
}

const dashboard = {
  dados_profissional: '/v2/api/professional/dashboard/get',
  att_profissional: '/v2/api/professional/dashboard/refresh',
}

const dashboardIndicadores = {
  relatorio_valuation: '/v2/api/general/relatorio_valuation/url',
}

const parametrizacao = {
  logo: '/v2/api/office/upload_logo',
  corretoras_vinculadas: '/v2/api/office/update_corretoras',
  team_list: '/v2/api/office/register_team',
}

const patrimonio_consolidado = {
  list: ({ clientId = -1 }) =>
    `/v3/api/aawz-financial-planning/clients/${clientId}/patrimony-consolidated`,
}

const minhaCarteira = {
  cliente: {
    avisos: '/v2/api/client/welcome_message/get',
    rentabilidade: '/v2/api/client/portfolio/quotation',
    composicao: '/v2/api/client/portfolio/graph',
    posicao: '/v2/api/client/portfolio/assets',
    evolucao: '/v2/api/client/portfolio/evolution',
    bancos: '/v2/api/professional/client/bank_accounts', // /<id_cliente>
    /**
     * @method GET Coletar as estatisticas com benchmark
     * Query params:
     * @param {String} group_by Forma de agrupamento. [id_ativo, classe, tipo, corretora] OBRIGATÓRIO
     * @param {String} begin_date Data de inicio para calculo. %d-%m-%Y
     * @param {String} end_date Data final para calculo. %d-%m-%Y
     * @param {Boolean} with_graph Se o gráfico vai junto
     *
     */
    estatisticas_benchmark: '/v2/api/client/portfolio/statistics',
    /**
     * @method GET Coletar informacoes da analise de portfolio
     * @param {Array} report_parts Partes consideradas do portfolio
     * @param {String} begin_date Comeco do filtro
     * @param {String} end_date Fim do filtro
     * @param {String} corretora Corretora para o filtro
     */
    analise_portfolio: '/v2/api/client/portfolio/report',
  },
  /**
   * Receber os avisos iniciais para a carteira do cliente
   * @param {String} id_cliente
   */
  avisos: '/v2/api/app/boas_vindas',
  /**
   *
   * @param {String} id_cliente
   */
  rentabilidade: '/v2/api/app/cotizacao/ler_rentabilidade_carteira/por_contas',
  /**
   * @param {String} id_cliente
   */
  evolucao: '/v2/api/app/cotizacao/ler_evolucao_patrimonial',
  /**
   *
   * @param {String} id_cliente
   */
  composicao: '/v2/api/app/composicao/fracoes',
  listar_clientes: '/v2/api/app/listar_clientes',
  /**
   *
   * @param {String} id_cliente
   */
  posicao: '/v2/api/app/cliente/posicao_completa',
  /**
   *
   * @param {String} id_cliente
   */
  get_roa: '/v2/api/app/get/roa',
  ativos_sugeridos: '/v2/api/client/suggest_asset/list',
  /**
   * @param {String} id_cliente
   */
  profissional_ativos_sugeridos:
    '/v2/api/app/profissional/suggest_asset/client/list',
  /**
   * Aceitar ativo sugerido
   * @param {String} suggestion_id
   */
  aceitar_ativo: '/v2/api/client/suggest_asset/accept',
  /**
   * Recusar ativo sugerido
   * @param {String} suggestion_id
   */
  rejeitar_ativo: '/v2/api/client/suggest_asset/reject',
  /**
   * Aceitar um lote de ativos
   * @param {String} suggestions_ids
   */
  aceitar_todos: '/v2/api/client/suggest_asset/accept_batch',
  /**
   * Recusar um lote de ativos
   * @param {String} suggestions_ids
   */
  rejeitar_todos: '/v2/api/client/suggest_asset/reject_batch',
  client_default: '/v2/api/professional/client_default/create', // GET
  first_login: '/v2/api/professional/dados_login/web/get', // GET
  analise_portfolio: '/v2/api/professional/reports/portfolio',
  /**
   * @method GET Coletar as estatisticas com benchmark
   * Query params:
   * @param {String} group_by Forma de agrupamento. [id_ativo, classe, tipo, corretora] OBRIGATÓRIO
   * @param {String} begin_date Data de inicio para calculo. %d-%m-%Y
   * @param {String} end_date Data final para calculo. %d-%m-%Y
   * @param {Boolean} with_graph Se o gráfico vai junto
   *
   */
  estatisticas_benchmark: '/v2/api/professional/portfolio/statistics/', // <id_cliente_app>
  /**
   * @method GET Consolidação on-demand de carteira (profissional)
   * Path params:
   * @param {Number} id id_cliente_app do cliente OBRIGATÓRIO
   * Query params (todos OPCIONAIS):
   * @param {String} group_by Dimensão do breakdown. [id_conta, corretora, tipo, subtipo, classe, subclasse, nome_ativo, nome_portfolio, emissor, tags, setor]
   * @param {String} tipo_investimento Filtra a consolidação. ["onshore", "offshore"]. Em offshore, retorna USD e ignora demais filtros (com warning).
   * @param {String} start_date Data inicial do período. Formato dd-MM-yyyy. (NÃO é `data_inicio`: a rota responde 400 Unknown parameter)
   * @param {String} end_date Data final do período. Formato dd-MM-yyyy.
   * @param {String} data_requested JSON.stringify de array, OBRIGATÓRIO. Blocos a incluir no response: ["PL", "rentabilidade", "rendimento", "pl0_ref", "monthly_return", "graph_composition", "statistics", "benchmarks", "splits", "proventos", "posicao_completa", "posicao_expandida"]. O que não estiver na lista NÃO é entregue (payload menor). `benchmarks` traz a série diária de cada benchmark do escritório, keyed pelo nome de exibição; `statistics` é quem popula `benchmark_relativo_nome` no breakdown. Lista completa e atual via `OPTIONS` na própria rota.
   * Filtros adicionais (todos OPCIONAIS, JSON.stringify de array):
   * @param {String} id_conta Lista de ids de conta. Ex: [1,2,3]
   * @param {String} corretora Lista de corretoras
   * @param {String} tipo Lista de tipos
   * @param {String} subtipo Lista de subtipos
   * @param {String} classe Lista de classes
   * @param {String} subclasse Lista de subclasses
   * @param {String} nome_portfolio Lista de portfólios
   * @param {String} emissor Lista de emissores
   * @param {String} tags Lista de tags. Comportamento overlap (ativo passa se interseção ≠ ∅).
   * @param {String} setor Lista de setores
   */
  consolidation: ({ id }) =>
    `/v2/api/professional/portfolio/consolidation/${id}`,
  /**
   * @method GET Consolidação on-demand de carteira (cliente — IS_CLIENTE)
   * Sem path params: id_cliente_app vem da session do cliente autenticado.
   * Query params: idênticos aos da rota profissional `consolidation` acima.
   */
  consolidationClient: '/v2/api/client/portfolio/consolidation',
}

const aporte = {
  client: {
    /**
     * Carregar proventos recebidos por um cliente.
     * @method GET
     */
    profits: '/v2/api/client/assets/proventos',
    /**
     * Carregar os splits/inplits dos ativos do cliente.
     * @method GET
     */
    splits: '/v2/api/client/assets/splits',
    /**
     * Listar as movimentacoes de um ativo
     * @param {Number} id ativo
     */
    list_by_asset:
      '/v2/api/client/financial-operations/movements/list_asset_account',
    list_by_client: '/v2/api/client/financial-operations/movements/list_client',
    /**
     * @param {Number} id_conta
     */
    list_by_account:
      '/v2/api/client/financial-operations/movements/list_account',
    /**
     * @param {Boolean} ativo_no_cei Se o ativo está presente no CEI.
     */
    list_grouped:
      '/v2/api/client/financial-operations/movements/list/grouped_by/asset',
    /**
     * @param {*} _
     */
    add: '/v2/api/client/financial-operations/movements/add',
    edit: '/v2/api/client/financial-operations/movements/edit',
    edit_inicial: '/v2/api/client/financial-operations/movements/initial/edit',
    /**
     * @param {Number} id_aplicacao
     */
    del: '/v2/api/client/financial-operations/movements/remove',
    suggestion: {
      /**
       * @param {Number} id_sugestao
       */
      accept: '/v2/api/client/financial-operations/movements/suggestion/accept',
      list: '/v2/api/client/financial-operations/movements/suggestion/list',
      /**
       * @param {Number} id_sugestao
       */
      reject: '/v2/api/client/financial-operations/movements/suggestion/reject',
    },
  },
  professional: {
    /**
     * Carregar proventos recebidos por um cliente.
     * @method GET
     */
    profits: '/v2/api/professional/client/assets/proventos/', // <int:id_cliente_app>
    /**
     * Carregar os splits/inplits dos ativos do cliente.
     * @method GET
     */
    splits: '/v2/api/professional/client/assets/splits/', // <int:id_cliente_app>
    /**
     * Listar as movimentacoes de um ativo
     * @param {Number} id_cliente_app
     * @param {Number} id ativo
     */
    list_by_asset:
      '/v2/api/professional/financial-operations/movements/list_asset_account',
    /**
     * @param {Number} id_cliente_app
     */
    list_by_client:
      '/v2/api/professional/financial-operations/movements/list_client',
    /**
     * @param {Number} id_cliente_app
     * @param {Number} id_conta
     */
    list_by_account:
      '/v2/api/professional/financial-operations/movements/list_account',
    /**
     * @param {Boolean} ativo_no_cei Se o ativo está presente no CEI.
     */
    list_grouped:
      '/v2/api/professional/financial-operations/movements/list/grouped_by/asset',
    /**
     * @param {Number} id_cliente_app
     * @param {Number} id_conta
     * @param {String} nome_ativo
     * @param {Number} valor
     * @param {Number} quantidade
     * @param {Number} valor_unitario
     * @param {String} data_aplicacao
     * @param {String} data_cotizacao
     * @param {Number} id ativo
     * @param {Number} resgate_total 1/0 - Boolean
     */
    add: '/v2/api/professional/financial-operations/movements/suggestion/add',
    /**
     * mesmos campos da adição
     * @param {Number} id_aplicacao
     */
    edit: '/v2/api/professional/financial-operations/movements/edition_suggestion/add',
    edit_inicial:
      '/v2/api/professional/financial-operations/movements/edition_suggestion/add',
    list: '/v2/api/professional/financial-operations/movements/suggestion/list',
    /**
     * @param {Number} id_sugestao
     */
    del: '/v2/api/professional/financial-operations/movements/suggestion/remove',
    /**
     * Rota para o profissional gerenciar as movimentações
     * @method POST adicionar (não precisa do id_aplicacao)
     * @method PUT editar movimentação
     * @method DELETE remover movimentação (precisa somente do id_cliente_app e id_conta)
     * @param id_cliente_app
     * @param id_conta
     * @param nome_ativo somente na adição
     * @param valor
     * @param quantidade
     * @param valor_unitario
     * @param data_aplicacao
     * @param data_cotizacao
     * @param id_ativo_cliente
     * @param resgate_total
     * @param editar_inicial somente na edição
     */
    manage: '/v2/api/professional/fin-ops/client/manage/', // <string:id_aplicacao>
    manage_add: '/v2/api/professional/fin-ops/client/manage',
  },
  /**
   *
   * @param {String} id_cliente
   */
  listar_por_cliente: '/v2/api/aporte_resgate/listar_por_cliente',
  /**
   * @param {String} data_aplicacao
   * @param {String} CNPJ
   */
  data_cotizacao: '/v2/api/general/fund/convert_quotation_date', // app: /produto/converter_data_cotizacao
}

const historicoAtividades = {
  /**
   * Coletar historico de atividades de uma carteira
   * /v2/api/general/client_position/logs/<string:id_cliente_app>
   * @param {String} id_cliente_app GET
   */
  coletar: '/v2/api/general/client_position/logs/', // GET <string:id_cliente_app>
}

const evolucaoPatrimonial = {
  profissional: {
    /**
     * Coletar dados para a tabela iterativa.
     * @method GET
     * @param {String} begin_date Data de inicio do filtro. Formato: DD-MM-YYYY
     * @param {String} end_date Data de fim do filtro. Formato: DD-MM-YYYY
     * @param {Array} corretora Lista de corretoras. Ex: ['BB', 'XP']
     * @param {Array} tipo Lista de tipos de ativos. Ex: ['RF', 'Fundo', 'FII']
     * @param {Array} classe Lista de classes. Ex: ['Renda Variável', 'Multimercado']
     * @param {Boolean} consider_xp Se considera a rentabilidade da XP -> não usar por enquanto
     */
    tabela: '/v2/api/professional/portfolio/monthly-statistics-detailed/', // <int:id_cliente_app>
    /**
     * Coletar a carteira do cliente em uma data especifica.
     * @method GET
     * @param {String} date Data para os dados. Formato: DD-MM-YYYY
     * @param {String} format Só lista por enquanto. -> não usar por enquanto.
     * @returns
     *  :value:
     *    :asset_with_date: Dados dos ativos com dados de cotização.
     *    :assets__withoud_data: Dados dos ativos sem dados de cotização.
     *    :date: Data solicitada.
     *    :_date: Data mais próxima da solicitada.
     *    :_format: formato usado.
     */
    carteira_data: '/v2/api/professional/portfolio/assets-at-date/', // <int:id_cliente_app>
  },
  cliente: {
    /**
     * Igual a rota do profissional
     */
    tabela: '/v2/api/client/portfolio/monthly-statistics-detailed',
    /**
     * Igual a rota do profissional.
     */
    carteira_data: '/v2/api/client/portfolio/assets-at-date',
  },
}

const servicos = {
  /**
   * Editar servico
   * @method PUT
   * @param {String} nome_servico
   * @param {String} descricao_servico
   * @param {Boolean} visivel
   * @param {Boolean} visivel_para_profissionais
   * @param {String} status
   * @param {FileStorage} imagem
   * @param {FileStorage} anexo
   * @param {FileStorage} logo
   */
  editar: '/v2/api/professional/services/offers/edit/', // <int:id_servico>
  ofertados: '/v2/api/general/services/offers/own/get',
  contratados: '/v2/api/general/services/subscribed/get',
  profissional: {
    disponiveis: '/v2/api/professional/services/visible_list', // GET
    /**
     * @param {Number} id_servico
     */
    cancelar: '/v2/api/professional/services/offers/cancel',
    /**
     * @param {String} codigo_servico
     * @param {String} id_servico
     */
    get_data: '/v2/api/professional/services/get_data',
  },
  cliente: {
    disponiveis: '/v2/api/client/services/visible_list', // GET
    /**
     * @param {Number} id_servico
     */
    cancelar: '/v2/api/client/services/subscription/unsubscribe',
    /**
     * @param {String} codigo_servico
     */
    get: '/v2/api/client/services/get',
  },
  /**
   * @param {List} id_servicos
   */
  generate_link_adesao: '/v2/api/professional/service/generate_link',
  link_indicacao: '/v2/api/professional/recommendation', // get
}

const controleClientes = {
  get: '/v2/api/professional/client-control/get',
  /**
   * Remover um prospect
   * @param {String} id_cadastro_cliente
   */
  deletar_prospect: '/v2/api/professional/prospect/delete',
  /**
   * Solicitar remoção de cliente
   * @param {String} id_cliente_app
   */
  deletar_cliente: '/v2/api/professional/client/deletion_request',
  bulk_set_active: '/v2/api/professional/client/data/bulk-set-active',
  /**
   * @method POST Remover cliente definitivamente
   * @param {Integer} id_cliente_app
   * @param {String} nome
   */
  remove_client: '/v2/api/professional/client/data/delete',
  /**
   * @method POST Filtrar clientes conforme parametros
   * @param {Array} filter Lista de parametros
   */
  filter: '/v2/api/professional/bi/client-data/search',
  /**
   * @method GET Lista origens de clientes disponiveis para o escritorio
   */
  origins: '/v2/api/general/clients/origins',
}

const acessoClientes = {
  /**
   * @method GET coletar permissões
   * @param {Integer} id_cliente_app opcional
   * @param {Integer} id_profissional opcional
   */
  /**
     * {id_profissional: [ids_clientes]}
     * {'read_access_add': {7: [1, 2, 3, 4], 8: [4, 2, 7]},
 'remove_access': {7: [1, 2, 3, 4], 8: [4, 2, 7]},
 'write_access_add': {7: [1, 2, 3, 4], 8: [4, 2, 7]}}
     */
  /**
   * -1 - permissão negada
   * 0 - somente leitura
   * 1 - leitura/escrita
   */
  manage: '/v2/api/professional/permissions/client-access/manage',
}

const propostas = {}

const configuracoes = {
  /**
   * Coletando dados dos profissionais completos
   * @method GET
   */
  dados_profissionais: '/v2/api/professional/professionals/get_full_data',
  profissionais: {
    /**
     * Rota para deletar os registros dos convites
     * @method POST
     * @param {Array} ids_convites
     */
    remover_convite: '/v2/api/office/professionals/delete-invites',
  },
  ativos: {
    /**
     * Replicar alteração de classe nos ativos dos clientes
     * @param {Array} ids_ativos Ativos que vão ser replicados
     */
    reply_changes: '/v2/api/manager/base-assets/replicate-changes',
    /**
     * Preview da propagação de ativos para clientes
     * @method POST
     * @param {Array} fields Campos a propagar
     * @param {Array} ids_ativos Ativos selecionados (opcional se select_all=true)
     * @param {Boolean} select_all Se deve propagar para todos os ativos
     */
    reply_changes_preview: '/v2/api/manager/base-assets/replicate-changes/preview',
    /**
     * @method PUT Atualizar ativos em lote.
     * @param {Object} dados_ativo Campos dos ativos a atualizar
     *          Permitidos: {classe: str, subclasse: str, utilizar: bool, fixar: bool}
     * @param {List} id_ativos Identificação dos ativos
     * @param {String} tipo Tipo de ativo sendo editado
     */
    update_batch: '/v2/api/professional/base-assets/manager/in-batch',
    /**
     * @method GET coletar ativos do escritório
     * @param {String} tipo tipo do ativo (Fundos, RF)
     * @param {Array} attributes campos sendo recarregados (Opcional)
     * @param {Integer} offset Qtd de ativos que vai "pular" pra começar a carregar
     * @param {Integer} limit Qtd de ativos carregados por página
     * @param {Object} filters Valores exatos dos atributos desejados
     * @param {Object} matches Campo para pesquisa por atributo
     * @param {Object} sort Ordenação {campo: direcao}
     */
    /**
     * @method POST adicionar ativo
     * @param {Object} dados_ativo
     * @param {String} tipo
     */
    /**
     * @method PUT editar ativo. /<id_ativo:int>
     * @param {Object} dados_ativo
     * @param {String} tipo
     */
    /**
     * Dados dos ativos (geral por enquanto)
     * @param {String} nome_ativo Obrigatório
     * @param {String} tipo Obrigatório [Já enviar na rota, não precisa aqui]
     * @param {String} classe Obrigatório
     * @param {Float} roa
     * @param {String} emissor
     * @param {String} liquidez
     * @param {String} taxa
     * @param {Date} carencia
     * @param {Date} vencimento
     * @param {Float} aplicacao_min
     * @param {Boolean} qualificado
     * @param {Boolean} utilizar Obrigatório
     * @param {Boolean} fixar Obrigatório (enviar como true - ele vai poder fixar o que tiver na base)
     * @param {Boolean} aberto
     * @param {Float} saldo_permanencia
     * @param {Float} mov_min
     * @param {String} referencia
     * @param {String} subtipo1
     * @param {Float} pu
     * @param {Integer} quantidade_minima
     * @param {String} agencia
     * @param {String} rating
     * @param {Date} data_observacao
     * @param {String} empresa
     * @param {String} gestora
     * @param {Integer} quantidade_disponivel
     * @param {Boolean} ranking
     * @param {String} cnpj_master
     * @param {Boolean} isento
     */
    manage: '/v2/api/professional/base-assets/manager',
    series: (idAtivo) => `/v2/api/professional/base-assets/series/${idAtivo}`,
    /**
     * Elasticsearch. Da pra enviar no corpo da requisição ou nos query params
     * @param {String} tipo Filtro. Vai trazer exatamente isso.
     * @param {Object} matches Pesquisa por like. Entrega resultados parecidos que podem corresponder.
     * @param {Object} sort Opcional. Cancela o ordenamento pela pesquisa. {nome_ativo: asc}
     * @param {Array} atributos Opcional. Campos coletados.
     * @param {Integer} limit Numero de elementos entregues.
     * @param {Integer} offset Numero de elementos ignorados para paginação.
     */
    /**
     * Recriar o índice do Elasticsearch para os ativos do escritório
     * @method POST
     */
    reindex_base: '/v2/api/professional/office/reindex-base-ativos',
  },
  blacklist: {
    /**
     * @method GET coletar blacklist
     * @returns
     *  value
     *    emissores
     *    gestoras
     *    ratings
     *    subtipos1
     *    tipo
     */
    /**
     * @method PUT adicionar/editar blacklist
     * @param {Object} blacklist {gestoras: [], emissores: [], ...}.
     *  Enviar o item inteiro para ter efeito, não precisa de todos os atributos.
     */
    manage: '/v2/api/professional/base-assets/blacklist/', // <str: tipo>
  },
  classes_estrategicas: {
    /**
     * @method GET Coletar subclasses do escritório
     *
     * @method POST Adicionar uma subclasse
     * @param {Object} data {classe, subclasse}
     *
     * @method PUT Atualizar uma subclasse
     * @param {Object} data {classe, subclasse}
     * @param {Integer} id Na rota. ex: /1
     *
     * @method DELETE Remover uma subclasse
     * @param {Integer} id Na rota. ex: /1
     */
    manage: '/v2/api/office/subclasses',
  },
  carteira_recomendada: {
    /**
     * @method GET Coletar as carteiras recomendadas.
     * @param {Integer} id Opcional - Inserir no final da rota: /1. - Se enviar,
     *  vai coletar os dados de uma carteira especifica.
     * @param {Boolean} with_assets Query params. Define se vai carregar os
     *  ativos da carteira.
     *
     * @method POST Adicionar carteira recomendada.
     * @param {Object} data Dados da carteira.
     *  { nome_carteira, descricao, tipo_destino, classe_destino, subclasse_destino}
     *
     * @method PUT Alterar uma carteira recomendada.
     * @param {Integer} id Opcional - Inserir no final da rota: /1. - Se enviar,
     *  vai coletar os dados de uma carteira especifica.
     * @param {Object} data Dados da carteira.
     *  { nome_carteira, descricao, tipo_destino, classe_destino, subclasse_destino}
     *
     * @method DELETE Remover uma carteira recomendada. Esta ação também apaga
     *  as carteiras dos portfolios modelos que têm ela.
     * @param {Integer} id Opcional - Inserir no final da rota: /1. - Se enviar,
     *  vai coletar os dados de uma carteira especifica.
     */
    manage: '/v2/api/professional/carteira_recomendada', // /<int:id>
    /**
     * @method GET Listar ativos de uma carteira ou um ativo especifico.
     *  Ex: 1/ativos
     * @param {Integer} id_carteira_recomendada Na propria rota - obrigatorio.
     * @param {Integer} _id Na propria rota - opcional.
     * @param {Boolean} with_assets Query param - Carregar ativos da carteira.
     *
     * @method POST Adicionar lista de ativos em uma carteira recomendada.
     *  Com /ativos depois do id da carteira. Ex: 1/ativos
     * @param {Integer} id_carteira_recomendada Na propria rota - obrigatorio.
     * @param {Array} data Dados dos ativos.
     *  { id_ativo, nome_ativo, alocacao_global, alocacao_especifica }
     * @param {Boolean} remove_on_missing Remover ativos que não forem encontrados.
     *
     * @method PUT Para editar um ativo especifico
     *  Ex: 1/ativos/1
     * @param {Integer} id_carteira_recomendada Na propria rota - obrigatorio.
     * @param {Integer} id Na propria rota - id do ativo.
     * @param {Object} data dados do ativo.
     *  { id_ativo, nome_ativo, alocacao_global, alocacao_especifica }
     *
     * @method DELETE Remover um ativo especifico da carteira.
     *  Ex: 1/ativos/1
     * @param {Integer} id_carteira_recomendada Na propria rota - obrigatorio.
     * @param {Integer} id Na propria rota - id do ativo.
     */
    ativos: '/v2/api/professional/carteira_recomendada/', // <int:id_carteira_recomendada>/ativos/<int:_id>
  },
  benchmark: {
    /**
     * @method GET Carregar DE-PARA
     * @param {String} atributo O que será considerado pra definir. Só 'classe' por enquanto.
     * @param {String} valor_atributo Pesquisar por uma classe específica.
     *
     * @method POST Salvar um DE-PARA classe e benchmark.
     * @param {String} atributo O que será considerado. Só 'classe' por enquanto.
     * @param {String} valor_atributo Classe considerada.
     * @param {String} benchmark
     *
     * @method PUT Editar um DE-PARA.
     * @params Igual POST.
     */
    manage: '/v2/api/professional/assets/benchmark-mapper',
    client_manage: '/v2/api/client/assets/benchmark-mapper', // Mesma lógica superior
  },
}

const configurarClientes = {
  /**
   * Gerenciar as Faixas de P/L.
   *
   * @method POST
   * @param {Array} segmentations Lista de valores das faixas. {nome, min, max (+)}
   */
  manage: '/v2/api/office/clients_segmentation/update',
  /**
   * Coletar dados do escritorio.
   */
  dados_escritorio: '/v2/api/office/data/get',
}

const configurarPlanilhas = {
  /**
   * @method GET Coletar os dados
   *  Soh pode salvar os dados se estiver '_atualizado' e 'valido'
   *  _available_worksheets: planilhas disponiveis
   *  _required_worksheets: obrigatorias
   *
   * @method POST Fazer upload de uma planilhas
   * @param {Object} data
   *  nome_planilha:str
   * @param {String} tipo Deve ser 'btg' por enquanto;
   * @param {Integer} id_cliente_app null enquanto for do btg;
   * @param {FileStorage} file
   */
  dados: '/v2/api/professional/worksheets/manager',
  /**
   * @method POST Escrever dados das planilhas
   * @param {String} tipo 'btg' por enquanto
   * @param {Integer} id_cliente_app null por enquanto
   */
  consolidar: '/v2/api/professional/worksheets/writer',
}

const importAssets = {
  /**
   * Baixar modelo
   * @method GET
   * @param {String} type Tipo do ativo (opcional)
   * @param {Boolean} model Se vai ser só o modelo ou a base inteira
   *  Se verdadeiro, não precisa de type por enquanto
   */
  modelo: '/v2/api/manager/base-assets/export',
  /**
   * Subir planilha/dados
   * @method POST
   * @param {FileStorage} file
   * @param {Array} table Lista de objetos
   * @param {Boolean} save Salvar ou apenas validar
   * @param {Array} data_to_add Lista de ativos para salvar
   *
   */
  importar: '/v2/api/manager/base-assets/import',
  /**
   * Habilitar somente um conjunto de ativos
   * @method POST
   * @param {Array} assets_to_enable Lista usada no filtro definido dps. Ex: cnpj1, cnpj2
   * @param {String} by_field Campo usado no filtro. referencia ou nome_ativo
   */
  enable: '/v2/api/manager/base-assets/enable/', // <string:tipo>
}

const portfolioModelo = {
  /**
   * @method GET Listar composições
   */
  read: '/v2/api/general/composition/manage',
  /**
   * @method POST Adicionar portfólio modelo.
   * @param {Object} dados Restrições da simulação.
   *
   * @method PUT Editar portfólio modelo.
   * @param {Object} dados Restrições da simulação.
   * @param {Integer} id_portfolio Identificação do portfolio modelo.
   *
   * @method DELETE Remover portfólio modelo.
   * @param {Integer} id_portfolio Identificação do portfolio modelo.
   */
  manage: '/v2/api/manager/composition/manage',
  /**
   * @method POST Definir a margem de suitability do escritorio.
   * @param {Number} tolerancia_variacao_alocacao_estrategica
   */
  suitability: '/v2/api/office/tolerance_strategic_allocation/update',
}

const simulador = {
  /**
   * Verificar se o profissional já gerou alguma simulação
   * @method GET
   */
  has_simulation: '/v2/api/professional/simulator/has_simulation',
  /**
   * Status da simulação
   * @param {Integer} id_cliente
   * @param {String} simulation_hash_code
   */
  status: '/v2/api/professional/simulator/get_status',
  /**
   * Rodar algoritimo
   * @param {Integer} id_cliente
   * @param {JSON} simulacao
   */
  run: '/v2/api/professional/simulator/run_algorithm',
  /**
   * @method GET Coletar lista de ativos atuais do cliente
   */
  ativos_atuais: '/v2/api/professional/client/assets', // ?id_cliente_app=6515
  /**
   * Backtest da simulação
   * @param {Integer} id_cliente id_cliente_app
   * @param {String} simulation_hash_code
   */
  sim_backtest: '/v2/api/professional/simulator/get_simulator_backtest',
  /**
   * Operações para a simulação
   * @param {Integer} id_cliente id_cliente_app
   * @param {String} simulation_hash_code
   */
  sim_operacoes: '/v2/api/professional/simulator/get_simulator_operations',
  /**
   * Ativos da simulação
   * @param {Integer} id_cliente id_cliente_app
   * @param {String} simulation_hash_code
   */
  sim_ativos: '/v2/api/professional/simulator/get_simulator_assets',
  /**
   * Dados da simulação
   * @param {Integer} id_cliente id_cliente_app
   * @param {String} simulation_hash_code
   */
  sim_data: '/v2/api/professional/simulator/get_simulator_result',
  ativos_sugeridos_update:
    '/v2/api/professional/simulator/ativos-sugeridos/update',
  /**
   * Coletar composições estratégicas
   */
  composicoes: '/v2/api/professional/simulator/strategic_position/list', // GET
  /**
   * Coletar todos ativos abertos
   */
  ativos_abertos: '/v2/api/assets/open/list', // GET
  /**
   * Coletar todos ativos existentes
   */
  ativos_geral: '/v2/api/assets/all/list', // GET
  /**
   * Ativos na base do escritório.
   */
  ativos_escritorio: '/v2/api/assets/in_office_base/list',
  /**
   * Coletar perfil do cliente
   * @param {Integer} id_cliente_app
   */
  perfil_cliente: '/v2/api/professional/simulator/client_perfil/get',
  /**
   * Coletar dados do cliente.
   * @method GET
   * @param {Integer} id_cliente_web id do cliente
   */
  dados_cliente: '/v2/api/professional/client/info/', // <int:id_cliente_app>
  /**
   * Rota para coletar informações da janela de tempo dos ativos.
   * @method GET
   */
  number_of_quotes: '/v2/api/assets/number_of_quotes?referencia=', // <referencia>
  /**
   * Listar simulações do cliente
   * @param {Integer} id_cliente_app
   */
  listar: '/v2/api/professional/simulator/simulations/list',
  /**
   * GET
   */
  lista_detalhes: '/v2/api/professional/simulations/',
  /**
   * @method GET coletar dados
   */
  analise: '/v2/api/professional/simulation/report/', // <id_cliente>?simulation_hash_code=<hash>&report_parts=monthly_return,portfolio_statistics,portfolio_scenarios
  /**
   * Não precisa do router parameter se for apagar em lote
   * @method PUT editar
   * @method DELETE apagar
   * @param id_cliente_app sempre
   * @param {Object} dados -editar novo
   * @param nome_simulacao editar
   * @param descricao editar
   * @param in_bach true -> apagar em lote
   * @param {List} hash_codes apagar em lote
   */
  manage: '/v2/api/professional/simulation/', // <string:hash_code>
}

const assinaturaEmail = {
  /**
   * @method POST Salvar assinatura de e-mail
   * @param {File} assinatura Imagem em PNG.
   *
   * @method GET Coletar assinatura
   * @param {Boolean} base64 Se sim, traz em base64. Se não, traz a url.
   */
  manage: '/v2/api/professional/email/signature/manage',
}

const resumoCliente = {
  /**
     * @method GET
     * @param {String} summary_parts Lista concatenada, separada por virgula para
     *  indicar os valores solicitados.
     *    Valores disponíveis: "assets_due_date", "client_data", "last_simulation",
     "subscription", "last_ips_date", "financial_data", "revenue_data".
     */
  dados: '/v2/api/professional/client-data/summary/', // <int:id_cliente_app>
}

const profissionais = {
  /**
   * @method POST Editar dados dos profissionais no consolidador
   * @param {Object} data Objeto do profissional
   *    nome:str
   *    telefone:str
   *    cpf:str
   *    data_nascimento:date
   */
  editar: '/v2/api/professionals/', // <int:id_profissional>
  /**
   * Route to remove professional
   * @method DELETE
   */
  remove: '/v2/api/professional/professionals/', // <id_profissional>
}

const mixProdutos = {
  /**
   * @param {String} group_by [segmentacao_por_pl, id_profissional, id_cliente]
   * @param {String} breakdown_by [tipo, classe, subclasse]
   * @param {Array} professionals_ids
   *
   * Dados gerais escritorio: group_by=['segmentacao_por_pl'], breakdown_by=['tipo']
   * Por profissional: group_by=['id_profissional'], breakdown_by=['tipo']
   * Clientes do profissional agrupado: group_by=['segmentacao_por_pl], breakdown_by=['tipo'], filters={'id_profissional: <id_profissional>'}
   * Clientes do profissional listados: group_by=['id_cliente'], breakdown_by=['tipo'], filters={'id_profissional': <id_profissional>}
   */
  manage: '/v2/api/aawz-product-mix/professional',
}

/* TELAS */

const informacoesCadastrais = {
  /**
   * @param {Integer} id_cliente
   * @param {Integer} id_cliente_web
   */
  collect_professional: '/v2/api/app/get/client_data',
  collect_user: '/v2/api/client/profile/view',
  edit_professional: '/v2/api/professional/self/data/edit',
  profissional_edit_client: '/v2/api/professional/client/data/edit',
  edit_user: '/v2/api/client/config/self/edit',
}

const mercadoFundos = {}

const mercadoAcoes = {}

const pdf = {
  /**
   * Rota para controlar a geração de pdf
   * @method POST
   * @param {String} corretora
   */
  run: '/v2/api/professional/reports/pdf/', // <id_cliente_app>
  /**
   * Verificar status do PDF
   * @method GET
   * @param {Boolean} download -> na rota: ?download=true
   */
  get: '/v2/api/professional/reports/pdf/', // <id_cliente_app>/<hash_code>
  /**
   * Rota para cliente verificar o status do pdf
   * @method GET
   * @param {Boolean} download -> na rota: ?download=true
   */
  client: '/v2/api/client/reports/pdf/', // <string:hash_code>
  cliente: {
    reports: '/v2/api/client/reports/pdf/',
  },
  portabilidade: {
    run: '/v2/api/professional/portability/pdf/', // <id_cliente_app>
    get: '/v2/api/professional/portability/pdf/', // <id_cliente_app>/<hash_code>
    client: {
      /**
       * Rota para controlar a geração de pdf
       * @method POST
       * @param {String} dados
       */
      run: '/v2/api/client/portability/pdf',
      /**
       * Verificar status do PDF
       * @method GET
       * @param {Boolean} download -> na rota: ?download=true
       */
      get: '/v2/api/client/portability/pdf/', // <string:hash_code>
    },
  },
  simulacao: {
    /**
     * Gerar PDF da simulacao
     * @method POST
     * @param {String} simulation_hash_code
     * @param {String} corretora
     */
    run: '/v2/api/professional/simulation/pdf/', // <int:id_cliente_app>
    /**
     * Verificar status da geração do pdf
     * @method GET
     */
    get: '/v2/api/professional/simulation/pdf/', // <int:id_cliente_app>/<string:hash_code>
  },
  lista_instituicoes: '/v2/api/general/instituicao/lista', // GET
}

const ips = {
  cliente: {
    /**
     * @method GET Coletar perguntas disponíveis para o cliente
     */
    questions: '/v2/api/client/ips/question/manage',
    /**
     * @method GET Coletar as respostas já realizadas
     */
    /**
     * @method POST Adicionar nova resposta
     * @param {Boolean} active Se a resposta está ativa ou não
     * @param {Object} question {id_question, content, tipo, opcoes}
     * @param {Object} answer_data {data, tipo}
     */
    /**
     * @method PUT Editar resposta
     * @param {Boolean} active Se a resposta está ativa ou não
     * @param {Object} answer_data {data, tipo}
     * @param {Integer} id_answer
     */
    /**
     * @method DEL Remover resposta
     * @param {Integer} id_answer
     */
    answers: '/v2/api/client/ips/answer/manage',
  },
  profissional: {
    /**
     * @method GET Coletar as observações sobre um cliente.
     */
    /**
     * @method POST Inserir nova observação
     * @param {String} text Conteúdo da observação.
     * @param {Integer} ordem Ordem de apresentação da observação
     */
    /**
     * @method PUT Editar observação existente
     * @param {String} text Conteúdo da observação.
     * @param {Integer} ordem Ordem de apresentação da observação
     * @param {Integer} id_observation
     */
    /**
     * @method DEL Remover uma observação
     * @param {Integer} id_observation
     */
    observations: '/v2/api/professional/ips/observation/manage/', // <string: id_cliente>
    /**
     * @method GET Coletar as perguntas de um escritório, se for id=1 não utilizar
     * @param {Boolean} public
     */
    /**
     * @method POST Adicionar novas perguntas
     * @param {String} content Titulo da pergunta
     * @param {String} tipo Formato esperado da resposta. Validos: 'text', 'money', 'percent', 'liquidez', 'perfil', 'radio', 'checkbox'
     * @param {Array} opcoes Opções de respostas válidas (opcional)
     * @param {Boolean} public Se a pergunta vai ser disponível para todos clientes. (opcional)
     * @param {Boolean} active Default: true. Se a pergunta é ativa ou não. (opcional)
     * @param {Array} ids_clientes Clientes específicos para a pergunta. (opcional)
     * @param {Integer} ordem
     * @param {String} grupo (opcional)
     */
    /**
     * @method PUT Editar pergunta existente
     * @params mesmos do POST
     * @param {Integer} id_question
     */
    /**
     * @method DEL Inativar pergunta
     * @param {Integer} id_question
     */
    questions: '/v2/api/professional/ips/question/manage',
    /**
     * @method GET Se o escritorio logado pode editar as perguntas do IPS.
     * @returns {Object} {pode_editar, motivo, mensagem}
     */
    editPermission: '/v2/api/professional/ips/question/edit-permission',
    /**
     * @method GET Se o escritório logado pode editar a FAIXA DE PONTUAÇÃO dos
     *   perfis. É a mesma liberação do questionário, com mensagem própria: o
     *   bloqueio é cirúrgico e não alcança a carteira modelo (alocação, ativos,
     *   liquidez), que segue editável.
     * @returns {Object} {pode_editar, motivo, mensagem}
     */
    profileRangePermission:
      '/v2/api/professional/ips/profile-range/edit-permission',
    /**
     * @method GET Régua de perfis EM VIGOR para o escritório da sessão.
     *
     * Resolvida pelos três degraus do padrão WS — é a MESMA régua que
     * classifica o cliente. `origem: 'template_ws'` = o escritório herda do
     * padrão; `'escritorio'` = régua própria (ou nenhuma).
     *
     * Separada do GET de composição de propósito: aquele tem 6 consumidores
     * (simulador, consolidador, respostas-cliente), e alterá-lo atingiria os
     * ~651 escritórios não-WS.
     *
     * @returns {Object} {origem, id_template, perfis: [{nome, pontuacao_min, pontuacao_max}]}
     */
    profileRange: '/v2/api/professional/ips/profile-range',
    /**
     * @method GET Coletar respostas de um cliente
     */
    /**
     * @method POST Salvar respostas
     * @param {Object} dados
     */
    answers: '/v2/api/professional/ips/answer/manage/', // <string: id_cliente>
    /**
     * @method POST Gerar PDF do IPS.
     * @param {Integer} id_cliente_app Na propria rota: /123.
     * @param {Integer} ips_version Form data.
     *
     * @method GET Buscar status e baixar PDF.
     * @param {Integer} id_cliente_app Na propria rota: /123.
     * @param {String} hash_code Na propria rota, depois do id cliente: /1asd12.
     */
    pdf: '/v2/api/professional/ips/pdf/',
  },
}

const templateEmail = {
  profissional: {
    /**
     * @method GET Listar templates de e-mail
     * @param {String} tipo Tipo de template buscado
     */
    manage: '/v2/api/professional/email/template/manage',
  },
  gestor: {
    /**
     * @method GET Listar templates de e-mail
     * @param {String} tipo Tipo de template buscado
     * @param {String} status Status do template
     *
     * @method POST Adicionar template de e-mail
     * @param {String} subject Assunto do e-mail.
     * @param {String} body Corpo de texto do e-mail.
     * @param {String} tipo Tipo de e-mail.
     *
     * @method PUT Editar template de e-mail
     * @param {String} subject Assunto do e-mail.
     * @param {String} body Corpo de texto do e-mail.
     * @param {String} tipo Tipo de e-mail.
     * @param {String} status Status do template [ATIVO, INATIVO].
     * @param {Integer} id_template Identificação.
     *
     * @method DELETE Remover um template de e-mail.
     * @param {Integer} id_template Identificação.
     */
    manage: '/v2/api/manager/email/template/manage',
  },
}

const exportar = {
  /**
   *
   */
  acesso_clientes: '/v2/api/professional/permissions/client-access/export',
  /**
   * @method POST
   * @param {File} file
   * @param {Object} table [{login_profissional, login_cliente, 'Com Acesso? (s\/n)'}]
   * @param {Boolean} save Salvar ou apenas validar
   */
  import_acesso_clientes:
    '/v2/api/professional/permissions/client-access/import',
  extrato: {
    /**
     * @method POST Exportar extrato consolidado
     * @param {Array} client_ids IDs dos clientes. Se vazio, exporta de todos.
     */
    exportar: '/v2/api/professional/position/client/export',
    /**
     * @method GET Baixar o modelo de planilha
     * @param {String} source Modelo da planilha. [comdinheiro, aawz]. Query param.
     *
     * @method POST Validar dados da planilha do cliente, se ok manda pro lambda.
     * @method PUT Fazer upload de planilha com extrato do cliente especifico.
     * @param {Integer} id_cliente_app Na rota. /id_cliente_app.
     * @param {FileStorage} file Planilha
     * @param {String} source Modelo da planilha [comdinheiro, aawz]
     */
    importar: '/v2/api/professional/position/worksheet',
    /**
     * Buscar dados dos clientes de login relacionando com uuid.
     * @method POST
     * @param {Array} client_ids Se vazio, recebe a base inteira.
     */
    dadosClientes: '/v2/api/professional/clients/export',
  },
}

const prospect = {
  /**
   * @method GET Listar prospects.
   * @param {String} status Filtro de status do prospect [ABERTO, ATENDENDO, FECHADO]. Default: ABERTO
   * @param {Boolean} only_professional Somente do profissional ou de escritório completo.
   *
   * @method PUT Editar o prospect.
   * @param {Integer} id_prospect
   * @param {Boolean} atendimento True: Abrir atendimento. False: Fechar atendimento.
   */
  manage: '/v2/api/professional/prospect/manage',
  /**
   * @method POST Enviar e-mail para os prospects e fechar atendimento.
   * @param {Array} prospects Lista de prospects [{id, email, simulacao_hash_code, status}]
   * @param {String} subject Assunto do e-mail
   * @param {String} body Corpo de texto do e-mail, pode ter html
   * @param {String} from E-mail do profissional remetente
   */
  email: '/v2/api/professional/prospect/email',
  /**
   * @method GET Baixar pdf do cliente
   */
  download_pdf: '/v2/api/professional/simulation/pdf/prospect', // <id_prospect>/<hash_code>
  /**
   * @method POST Listar simulações do cliente
   * @param {Integer} id_prospect Identificacao
   */
  listar_simulacoes: '/v2/api/professional/simulator/simulations/prospect/list',
}

const emailHistorico = {
  /**
   * @method GET Listar e-mails enviados
   * @param {Boolean} only_professional Somente e-mails enviados pelo profissional.
   */
  manage: '/v2/api/professional/email/historico/manage',
}

const modeloPDF = {
  /**
   * @method GET Listar modelos disponíveis para o escritorio.
   */
  modelos: '/v2/api/professional/pdf/modelo',
  /**
   * @method POST Salvar arquivo
   * @param {String} tipo Tipo do arquivo
   * @param {FileStorage} file Arquivo
   *
   * @method GET Buscar arquivo
   * @param {Boolean} base64 Se quer o base64 ou url
   * @param {String} tipo Tipo do arquivo
   */
  arquivo: '/v2/api/professional/modelo/pdf/', // <int:id_pdf_modelo>
  /**
   * @method GET Listar partes de um modelo
   * @param {Integer} id_pdf_modelo Identificador do modelo
   */
  partes: '/v2/api/professional/pdf/modelo/parte',
  /**
   * @method GET Listar os templates disponíveis
   */
  templates: '/v2/api/professional/pdf/modelo/template',
  /**
   * @method POST Renderiza a pré-visualização do modelo com os templates REAIS
   * do relatório e dados de exemplo (spec-008). Aceita a configuração atual do
   * editor, mesmo sem salvar.
   * @param {Integer} id_pdf_modelo
   * @param {Integer} versao 2 = clássico, 3 = novo
   * @param {Array} partes [{ nome, ordem }] — estado atual do editor
   * @param {String} cor Cor primária (--brand); vazio = cor do escritório
   */
  preview: '/v2/api/professional/pdf/modelo/preview',
  /**
   * Rota para controlar a geração de pdf
   * @method GET Download e buscar status
   * @param {Boolean} download
   *
   * @method POST Gerar PDF
   * @param {Integer} id_pdf_modelo
   * @param {String} simulation_hash_code
   */
  gerar: '/v2/api/professional/report/customized/pdf/', // <int:id_cliente_app>/<string:hash_code>
}

const composicaoFundo = {
  /**
   * Gerenciar a composicao dos fundos na base do escritorio.
   *
   * @method GET Listar os ativos debaixo de um fundo.
   *
   * @method PUT Adicionar/Editar composicao de um fundo. Enviar todos os ativos.
   * @param {Array} data Lista de ativos. Precisa fechar 100 na alocacao.
   *    nome_ativo
   *    tipo
   *    classe
   *    alocacao_percentual
   *    id_ativo_composicao = ?id_ativo?
   */
  manage: '/v2/api/professional/base-assets/fund-composition/', // <int:id_ativo>
}

const bpo = {
  /**
   * @method GET Listar as areas de produtos
   *
   * @method POST Adicionar area de produtos
   * @param {Object} data Dados da area
   *    id_pj:int
   *    area_receita:str
   *
   * @method PUT Editar area de produtos
   * @param {Integer} id_area_produto No final da rota. Ex: /1
   * @param {Object} data Dados da area
   *   id_pj:int
   *   area_receita:str
   */
  areas: '/v2/api/aawz-partners/bpo/financial/revenue-areas',
  rubricsAll: '/v2/api/aawz-partners/bpo/financial/rubricas',
  /**
     * @method PUT Adicionar/Editar rubricas de uma area de receita
     * @param {Array} rubricas Lista das rubricas para a area de receita
     * @returns {`/v2/api/aawz-partners/bpo/financial/revenue-areas/${string}/rubricas`} URL para alterar as rubricas
     de uma area.
     */
  rubrics: ({ id_area_receita }) =>
    `/v2/api/aawz-partners/bpo/financial/revenue-areas/${id_area_receita}/rubricas`,
  /**
   * @method GET Listar metricas de rateio.
   *
   * @method POST Adicionar uma metrica de rateio
   * @param {Object} data Dados da metrica
   *    nome_metrica:str
   *    fator_aplicado:str
   *    descricao:str
   *
   * @method PUT Editar uma metrica de rateio
   * @param {Integer} id Na rota. Ex: /1
   * @param {Object} data Dados da metrica - igual ao post.
   *
   * @method DELETE Remover uma metrica de rateio
   * @param {Integer} id Na rota. Ex: /1
   */
  metrics: '/v2/api/aawz-partners/bpo/financial/apportionment-metrics',
  /**
   * @method GET Listar categorias
   *
   * @method POST Adicionar categoria
   * @param {Object} data
   *    categoria:str
   *    subcategoria:str
   *    grupo_categoria:str
   *    custo_direto:boolean
   *    id_metrica_rateio_pj:int
   *    id_metrica_rateio_area_receita:int
   */
  categories: '/v2/api/aawz-partners/bpo/financial/categories/config',
  /**
   * @method GET Listar linhas de resultados
   * @returns {Object} {value: {[]}}
   */
  resultLines: '/v2/api/aawz-partners/bpo/financial/dre/linhas-resultado',
  /**
   * @method GET Listar plano de contas
   * @returns {Object} {status: int, message: string: value: Dicionario}
   */
  listaPlanoDeContas: '/v3/api/aawz-partners/bpo/financial/plano-de-contas',
  /**
   * @method GET Listar comissões dos clientes
   *
   * @method POST Busca comissões dos clientes com dados de outras tabelas
   *
   * @method GET /segmentation/:id Busca as comissões agrupadas por segmentacao -> só se precisar dos
   * dados da segmentação e não tiver (usar opção de cima).
   */
  margin: '/v2/api/aawz-partners/bpo/comissions-clients',
  marginAdvisor: '/v2/api/aawz-partners/bpo/comissions-advisors',
  dre: {
    /**
     * @method GET Listar a DRE agrupado por PJ
     * @param {Array<Number>} ids Filtro por PJs
     * @param {String} end_date DD-MM-YYYY Enviar ultimo dia do mês
     * @param {String} begin_date DD-MM-YYYY Enviar ultimo dia do mês
     * @param {Boolean} breakdown_by_date Se vai quebrar a DRE por datas
     * @param {String} frequency Agrupamento das datas
     */
    byPjs: '/v2/api/aawz-partners/office/dre/by-pj',
    /**
     * @method GET Listar a DRE agrupado por PJ
     * @param {Array<Number>} ids Filtro por PJs
     * @param {String} end_date DD-MM-YYYY Enviar ultimo dia do mês
     * @param {String} begin_date DD-MM-YYYY Enviar ultimo dia do mês
     * @param {Boolean} breakdown_by_date Se vai quebrar a DRE por datas
     * @param {String} frequency Agrupamento das datas
     */
    byAreas: '/v2/api/aawz-partners/office/dre/by-area-receita',
    byFilials: '/v2/api/aawz-partners/office/dre/by-filial',
    /**
     * @method POST Listar a DRE do profissional
     * @param {Number} id_profissional
     * @param {String} begin_date DD-MM-YYYY Enviar ultimo dia do mês
     * @param {String} end_date DD-MM-YYYY Enviar ultimo dia do mês
     * @param {String} freq Frequencia de agrupamento. [M, Q, Y]
     */
    byProfessional: '/v2/api/aawz-partners/office/dre/by-profissional',
    /**
     * @method POST Listar a DRE das equipes
     * @param {Number} id_profissional
     * @param {String} begin_date DD-MM-YYYY Enviar ultimo dia do mês
     * @param {String} end_date DD-MM-YYYY Enviar ultimo dia do mês
     * @param {String} freq Frequencia de agrupamento. [M, Q, Y]
     */
    byTeam: '/v3/api/aawz-partners/bpo/financial/dre/team-historical', // '/v3/api/aawz-partners/bpo/financial/dre/teams',
    // byProfessional: '/v3/api/aawz-partners/bpo/financial/result-lines-comissions/professional-historical',
    /**
     * @method POST Listar a DRE do profissional
     * @param {Number} id_profissional
     * @param {String} begin_date DD-MM-YYYY Enviar ultimo dia do mês
     * @param {String} end_date DD-MM-YYYY Enviar ultimo dia do mês
     * @param {String} freq Frequencia de agrupamento. [M, Q, Y]
     */
    // professionalIndividual: '/v3/api/aawz-partners/office/dre/by-professional',
    professionalIndividual:
      '/v3/api/aawz-partners/bpo/financial/result-lines/professional-historical',
  },
  dreTemp: {
    byPjs: '/v2/api/aawz-partners/office/dre-temp/by-pj',
    byAreas: '/v2/api/aawz-partners/office/dre-temp/by-area-receita',
    byFilials: '/v2/api/aawz-partners/office/dre-temp/by-filial',
    byProfessional: '/v2/api/aawz-partners/office/dre-temp/by-profissional',
    byTeam: '/v2/api/aawz-partners/office/dre-temp/by-equipe',
    summaryProfessionals: '/v2/api/aawz-partners/office/dre-temp/summary/professionals',
    summaryTeams: '/v2/api/aawz-partners/office/dre-temp/summary/teams',
    summaryRevenueAreas: '/v2/api/aawz-partners/office/dre-temp/summary/revenue-areas',
    summarySubsidiaries: '/v2/api/aawz-partners/office/dre-temp/summary/subsidiaries',
  },
  /**
   * @method GET Coletar dados de valuation da estrutura do pj
   */
  valuationOffice: '/v2/api/aawz-partners/bpo/financial/valuation',
  /**
   * @method GET Coletar lista de valuations do profissional
   */
  valuationProfessional:
    '/v2/api/aawz-partners/bpo/financial/valuation/professional/', // <int:id_profissional>
  /**
   * @method POST Listar partnerships do profissional
   * @param {Number} id_profissional
   */
  partnershipProfessional:
    '/v3/api/aawz-partners/business-intelligence/partnership',

  /**
   * @method GET Coletar lista das comissões de uma categoria em uma data específica
   */
  getDetailsForCategory: (optionDetails, queryParams) =>
    `/v3/api/aawz-bpo-contralodoria/dre/detail/${optionDetails}${queryParams}`,
}

const office = {
  /**
   * @method GET Coletar dados gerais do escritorio
   */
  general: '/v2/api/office/',
}

/* MODAIS */

const cadastroClientes = {
  novo_cliente: '/v2/api/app/app_clientes/cadastro/modal/save',
  planilha_modelo: '/v2/api/app/app_clientes/cadastro/planilha/modelo',
  ler_planilha: '/v2/api/app/app_clientes/cadastro/planilha/upload',
  salvar_planilha: '/v2/api/app/app_clientes/cadastro/planilha/save',
  send_announcement: '/v2/api/professional/register_client/send_inform',
  send_announcement_client:
    '/v2/api/professional/register_client/send_inform/client',
  // get_assessores: '/v2/api/professional/assessors/get',
  get_assessores: '/v2/api/professional/professionals/get',
  get_profissionais: '/v2/api/professional/professionals/get',
  /**
   *
   * @param {Integer} id_cliente
   * @param {List} ids_servicos
   */
  generate_link: '/v2/api/professional/register_client/services/update',
  generate_link_whitelabel:
    '/v2/api/professional/register_client/services/update/client',
  /**
   * Enviar link adesão para prospect
   * @params equals app
   */
  send_link: '/v2/api/professional/register_client/send_link',
  /**
   * Enviar link adesão para cliente final
   * @params equals app
   */
  send_link_client: '/v2/api/professional/register_client/send_link/client',
}

const assetAllocation = {
  /**
   * Rota para exportar os valores do fee a ser cobrado em um mês específico
   * @param {String} data_referencia Data de referência para exportação. Formato: DD-MM-YYYY
   * @param {Array} ids Lista de IDs para filtrar a exportação.
   */
  feeExport: '/v3/api/asset-allocation/fee/export',
}

const avenueImport = {
  /**
   * Pré-visualização da importação de clientes Avenue via planilha
   * @method POST multipart/form-data com campo "file" (.xlsx ou .csv)
   */
  preview: '/v3/api/avenue-import/preview',
  /**
   * Execução da importação de clientes Avenue após confirmação da pré-visualização
   * @method POST JSON com array "rows"
   */
  execute: '/v3/api/avenue-import/execute',
  /**
   * Download do template de importação Avenue (.xlsx)
   * @method GET
   */
  template: '/v3/api/avenue-import/template',
}

const contrato = {
  /**
   * Rota para assinar contrato de adesão de whitelabel
   * @param {String} nome_responsavel
   * @param {String} cnpj com mascara
   * @param {String} nome_escritorio
   * @param {String} telefone
   */
  assinar: '/v2/api/professional/white_label/contract',
  read: '/v2/api/professional/white_label/contracted',
}

const cadastroServico = {
  /**
   * @deprecated Usar GET pagarme.check_receiver
   */
  check_wirecard: '/v2/api/professional/seller/moip-account/check',
  /**
   * @deprecated Usar POST pagarme.add_receiver
   * @param {String} email
   * @param {String} number_doc
   * @param {String} name
   * @param {String} descricao opcional
   * @param {String} lastname
   * @param {String} tipo_doc
   * @param {String} data_nascimento formato wirecard?
   * @param {Number} areaCode
   * @param {String} telefone
   * @param {String} rua
   * @param {Number} numero_rua
   * @param {String} bairro
   * @param {String} cep
   * @param {String} cidade
   * @param {String} estado
   * @param {Number} countryCode 55
   * @param {String} empresa_nome_fantasia
   * @param {String} empresa_razao_social
   * @param {String} empresa_tipo_doc CNPJ
   * @param {String} empresa_numero_doc
   * @param {Number} empresa_codigo_area
   * @param {Number} empresa_telefone_numero
   * @param {String} empresa_rua
   * @param {Number} empresa_numero
   * @param {String} empresa_endereco_complemento
   * @param {String} empresa_bairro
   * @param {String} empresa_cep
   * @param {String} empresa_cidade
   * @param {String} empresa_estado
   * @param {String} empresa_pais BRA
   */
  add_wirecard: '/v2/api/professional/seller/moip-account/add',
  /**
   * @param {String} nome_servico
   * @param {String} descricao_servico
   * @param {String} tipo_servico ?
   * @param {Number} taxa
   * @param {String} tipo_taxa ?
   * @param {Number} taxa_recorrente
   * @param {String} tipo_taxa_recorrente
   * @param {Number} valor_minimo_recorrencia
   * @param {Boolean} free
   * @param {Boolean} visivel
   * @param {Number} numero_parcelas
   *
   * @returns {Object} {id_servico, codigo_servico}
   */
  add_service: '/v2/api/professional/services/offers/add',
}

const contratarServico = {
  /**
   * @deprecated Usar POST add_pagarme_account
   * @param {String} nome
   * @param {String} email
   * @param {String} data_nascimento formato wirecard
   * @param {String} tipo_doc CPF/CNPJ
   * @param {String} numero_doc
   * @param {Number} areaCode
   * @param {String} telefone
   * @param {String} cidade
   * @param {String} bairro
   * @param {String} rua
   * @param {Number} numero_rua
   * @param {String} cep
   * @param {String} estado
   * @param {String} complemento
   * @param {String} pais BRA
   * @param {Number} countryCode 55
   */
  add_wirecard_account: '/v2/api/client/card_data/add_client_wirecard',
  /**
   * @method POST Adicionar cliente na pagarme.
   * @method GET Verificar se existe o cliente na pagarme.
   *    @return status===200 -> Tem cadastro e Tem cartão.
   *    @return status===403 -> Tem casdastro e Não tem cartão.
   *    @return status===404 -> Não tem cadastro e Não tem cartão.
   * Parametros iguais a rota anterior.
   */
  add_pagarme_account: '/v2/api/payments/pagarme/payer/client/account',
  /**
   * @deprecated Usar POST add_pagarme_card
   * @param {String} data_vencimento MM/YY
   * @param {String} numero
   * @param {Number} cvc 000
   * @param {String} countryCode 55
   * @param {String} areaCode
   * @param {String} telefone
   * @param {String} nome_cartao
   * @param {String} tipo_doc CPF/CNPJ
   * @param {String} numero_doc
   * @param {String} data_nascimento formato wirecard
   */
  add_card: '/v2/api/client/card_data/add_card',
  /**
   * @method POST Adicionar cartão na Pagarme
   * @method GET Coletar cartões cadastrados.
   * @method DELETE Remover cartão cadastrado.
   * Parametros iguais anteriores.
   */
  add_pagarme_card: '/v2/api/payments/pagarme/payer/client/credit-card',
  /**
   * @param {String} codigo_servico
   */
  contratar: '/v2/api/client/services/subscription/contract_batch', // Fazer diferenciação para contratar e contratar nao pagante
  /**
   * @deprecated Usar GET add_pagarme_account
   * @return 200 - tem tudo; 403 - tem cadastro wirecard; 404 - Não tem nada
   */
  verificar_conta: '/v2/api/client/card_data/check_client',
  /**
   * @deprecated User DELETE add_pagarme_card
   * @param {String} id_cartao
   */
  remover_card: '/v2/api/client/card_data/get_cards/remove_card',
}

/**
 * Rotas para o gerenciamento de serie historica de rentabilidade dos ativos
 * inseridos manual, conforme o tipo "Personalizado".
 */
const historicoAtivo = {
  cliente: {
    /**
     * @method GET Baixar dados historicos do ativo.
     * @param {Boolean} template Query param. Se baixa os dados reais ou um template.
     * @returns Binario do arquivo csv.
     *
     * @method DELETE Remover os historicos
     *
     * @method PUT Atualizar dados historicos
     * @param {FileStorage} file Excel ou csv, com colunas 'data' e 'valor_cota'. Obrigatório.
     * @param {Boolean} overwrite Se vai apagar os dados anteriores, se for false, apaga dado duplicado e mantem mais novo.
     * @returns
     *    Se correto: resposta padrao com status:200.
     *    Se tiver algo errado, resposta padrão para planilhas, com JSON com campos validos e invalidos.
     */
    salvar: ({ id_ativo = -1 } = {}) => {
      return `/v2/api/client/position/assets/${id_ativo}/manual-quotas`
    },
  },
  profissional: {
    /**
     * @method GET Baixar dados historicos do ativo.
     * @param {Boolean} template Query param. Se baixa os dados reais ou um template.
     * @returns Binario do arquivo csv.
     *
     * @method DELETE Remover os historicos
     *
     * @method PUT Atualizar dados historicos
     * @param {FileStorage} file Excel ou csv, com colunas 'data' e 'valor_cota'. Obrigatório.
     * @param {Boolean} overwrite Se vai apagar os dados anteriores, se for false, apaga dado duplicado e mantem mais novo.
     * @returns
     *    Se correto: resposta padrao com status:200.
     *    Se tiver algo errado, resposta padrão para planilhas, com JSON com campos validos e invalidos.
     */
    salvar: ({ id_cliente = -1, id_ativo = -1 } = {}) => {
      return `/v2/api/professional/position/client/${id_cliente}/assets/${id_ativo}/manual-quotas`
    },
    /**
     * Importar planilha com historico para ativos personalizados na base do escritorio.
     * Mesmos parametros da parte normal.
     */
    settings: '/v2/api/manager/base-assets/manual-quotas/', // <int:id_ativo>
  },
}

/**
 * @deprecated Usar rotas no contratarServico
 */
const wirecardCliente = {
  // Ver parametros
  get_cards: '/v2/api/client/card_data/get_cards',
  get_data: '/v2/api/client/card_data/get_wirecard_data',
  remove_card: '/v2/api/client/card_data/get_cards/remove_card',
}

const pagarme = {
  /**
   * @method POST Cadastrar conta recebedora
   * Mesmos parametros da conta wirecard
   */
  add_receiver: '/v2/api/payments/pagarme/receiver/professional/account',
  /**
   * @method GET Verificar conta recebedora
   * Mesmos parametros da conta wirecard
   */
  check_receiver: '/v2/api/payments/pagarme/receiver/professional/account',
  /**
   * @method GET Listar contas bancárias -> Não precisa de parametros
   * @method POST Cadastrar conta bancaria recebedora
   * @method PUT Editar a conta bancaria
   *
   * @param {Integer} id_conta_recebedor
   * @param {String} banco
   * @param {Integer} cod_banco
   * @param {String} nome_banco
   * @param {Integer} agencia
   * @param {Integer} agencia_digito
   * @param {Integer} conta
   * @param {Integer} conta_digito
   * @param {Integer} numero_banco
   *
   * @param {String} nome_legal Se não informar, vai usar 'empresa_razao_social',
   *        se não tiver também, vai juntar 'name' e 'lastname'
   * @param {String} cpf_cnpj Se não informar, usa 'empresa_numero_doc',
   *        se não tiver também, vai usar 'number_doc'
   */
  add_bank_account:
    '/v2/api/payments/pagarme/receiver/professional/bank-account',
  migracao: '/v2/api/payments/pagarme/receiver/professional/migration',
  /**
   * @method GET Verificar saldos na pagarme
   *    @returns on value
   *        available.amount -> valor disponível para saque na conta.
   *        waiting_funds.amount -> valor a receber.
   *        transferred.amount -> valor já transferido.
   */
  saldo: '/v2/api/payments/pagarme/receiver/professional/balance',
  /**
   * @method GET Apresentar transferências realizadas.
   * @returns Usar campos com '_' no final, são campos tratados.
   *
   * @method POST Transferir saldo.
   * @param {Number} amount Valor a ser transferido, em reais.
   */
  transferencias: '/v2/api/payments/pagarme/receiver/professional/transfer',
}

const cadastroAtivo = {
  /**
   * Rota para o profissional gerenciar o ativo
   * @method POST adicionar ativo (não precisa do id_ativo)
   * @method PUT editar ou transferir (id_conta_nova) ativo
   * @method DELETE remover ativo
   * @params mesmos parametros de adição do cliente
   * @param id_conta_nova somente na transferencia
   */
  profissional: '/v2/api/professional/position/client/manage/', // <string:id_ativo>
  profissional_add: '/v2/api/professional/position/client/manage',
  ativos: {
    adicionar: '/v2/api/app/profissional/suggest_asset/modal/save',
    parametros: '/v2/api/general/asset/parameters/get',
    adicionar_client: '/v2/api/client/v1/produto/adicionar',
    editar: '/v2/api/client/v1/produto/editar',
    edit_name: '/v2/api/professional/position/client/edit-name/',
    editar_profissional: '',
    remover: '/v2/api/client/v1/produto/remover',
    transferir: '/v2/api/client/v1/produto/transferir',
  },
  suggestion: {
    /**
     * Profissional sugerir edição
     * @param {*} * iguais da sugestão normal
     * @param {Number} id_ativo_cliente campo 'id' do ativo do cliente
     */
    add_edit: '/v2/api/app/profissional/suggest_asset_edit/modal/save',
    list: '/v2/api/client/suggest_asset_edit/list',
    /**
     * Cliente aceitar sugestão
     * @param {Number} id_ativo_cliente campo 'id' do ativo do cliente
     */
    accept: '/v2/api/client/suggest_asset_edition/accept',
    /**
     * Cliente aceitar todas as sugestões
     */
    accept_all: '/v2/api/client/suggest_asset_edition/accept_batch',
    /**
     * Cliente rejeitar sugestão
     * @param {Number} id_ativo_cliente campo 'id' do ativo do cliente
     */
    reject: '/v2/api/client/suggest_asset/reject',
    /**
     * Cliente rejeitar todas as sugestões
     */
    reject_all: '/v2/api/client/suggest_asset/reject_batch',
  },
  bancos: {
    /**
     *
     * @param {String} id_cliente
     */
    listar: '/v2/api/app/profissional/app_cliente/bancos_corretoras/get',
    listar_client: '/v2/api/client/bank-account/registered/get',
  },
  search: {
    acoes: '/v2/api/general/search/acoes',
    fii: '/v2/api/general/search/fiis',
    fundos: '/v2/api/general/search/fundos',
    classe_fundos: '/v2/api/general/fund/class/get',
    personalizado: '/v2/api/general/search/personalizado',
    offshore: '/v2/api/general/search/offshore',
    bonds: '/v2/api/general/search/bonds',
    fundosOffshore: '/v2/api/general/search/fundos-offshore',
  },
}

const acoesLoteConsolidador = {
  cliente: {
    /**
     * Igual acoesLoteConsolidador.profissional.ativo
     * Não precisa enviar id_cliente_app
     */
    ativo: '/v2/api/client/produto/editar_em_lote',
  },
  profissional: {
    /**
     * Editar ativos da carteira do cliente em lote.
     * @method PUT
     * @param {Integer} id_cliente_app
     * @param {Object} dados_ativo
     *  Campos aceitos:
     *    ['nome_portfolio','tipo','subtipo','comentario','tags']
     *     classes: [{id, classe, subclasse}]
     * @param {Array} ids_ativos Lista dos ids
     * @returns
     *  _n_assets_to_update
     *  _n_assets_updated
     *  message
     */
    ativo: '/v2/api/professional/position/client/manage-in-batch',
  },
}

const adicionarTransacao = {
  bancos: {
    contas_cliente: '/v2/api/client/bank-account/list',
    manuais: '/v2/api/client/bank-account/custom/get',
    automaticos: '/v2/api/client/bank-account/registered/get',
    /**
     * @param {Boolean} cotizar_conta True quando a cotização for calculada pela AAWZ
     */
    edit: '/v2/api/client/bank-account/edit',
    delete: '/v2/api/client/bank-account/remove',
    att: '/v2/api/client/crawler/banks/redirect',
    listar: '/v2/api/general/banks/get',
    /**
     * @param {Boolean} cotizar_conta True quando a cotização for calculada pela AAWZ
     */
    add: '/v2/api/client/bank-account/add',
    crawlers: '/v2/api/client/crawler/send_all',
  },
}

const contaInvestimento = {
  /**
   * Remover uma conta manual
   * @param {String} corretora
   */
  remover: '/v2/api/client/bank-account/custom/remove',
  /**
   * @method POST Adicionar uma conta bancaria nao automatica
   *  id_banco
   *  conta
   */
  addContaNaoAutomatica: {
    cliente: '/v2/api/client/bank-account-not-automatic/add',
    profissional: '/v2/api/professional/client/bank_accounts_not_automatic/', // id_cliente_app
  },
}

const cadastroAporte = {}

const cadastroProfissional = {
  register_professionals: '/v2/api/office/register_professionals',
}

const gerenciarProfissional = {
  /**
   * @method PUT editar role
   * @param {Integer} roles {id_profissional, id_role}
   *      - 1: Admin (Gestor)
   *      - 3: Assessor
   *      - 4: Back-office
   */
  edit_role: '/v2/api/professional/permissions/roles/manage', // /<int:id_profissional>
}

const comunicacaoEmail = {}

const comunicacaoPush = {
  /**
   * @param {String} conteudo texto sendo enviado no corpo
   * @param {String} nome titulo do push
   * @param {List} clientes ids dos clientes que vão receber
   * @param {Boolean} send_push enviar push notification
   * @param {Boolean} send_feed enviar mensagem no feed (comunicado)
   * @param {String} title Titulo (utilização desnecessária)
   * @param {String} url link para notícia
   */
  enviar: '/v2/api/professional/push/send',
  ler: '/v2/api/general/push/read',
  ler_todas: '/v2/api/general/push/read_all',
  qtd: '/v2/api/general/push/qtd_not_read',
}

const atualizar = {
  run: '/v2/api/client/quotation/calculate_portfolio', // GET
  /**
   * @param {String} id_cliente_app
   */
  professional: '/v2/api/professional/client/quotation/calculate_portfolio',
  /**
   * @method GET
   */
  status: '/v2/api/client/quotation/get-status',
  /**
   * @method GET
   * @param {String} id_cliente_app Como query param.
   */
  professional_status: '/v2/api/professional/client/quotation/get-status',
}

const vincularContas = {
  cliente: {
    /**
     * @method GET
     * @returns lista com dicionarios:
     *    id_conta, agencia, conta, cpf, email, conta_corretora, id_conta_cei,
     *    status, total_investido, data_coleta e data_criaca.
     */
    listar_destinos: '/v2/api/client/bank-account/merge',
    /**
     * @method POST Vincular
     * @method PUT Desvincular
     * @param {Integer} id_conta_origem Conta menor
     * @param {Integer} id_conta_destino Conta principal
     */
    mesclar: '/v2/api/client/bank-account/merge',
  },
  professional: {
    /**
     * @method GET
     */
    listar_destinos: '/v2/api/professional/client/bank_accounts/merge/', // <int:id_cliente>
    /**
     * @method POST Vincular
     * @method PUT Desvincular
     * @param {Integer} id_conta_origem
     * @param {Integer} id_conta_destino
     */
    mesclar: '/v2/api/professional/client/bank_accounts/merge/', // <int:id_cliente>
  },
}

const vincularAtivos = {
  /**
   * Vincular as movimentações do ativo.
   * @method POST
   * @param {Integer} id_ativo_origem
   * @param {Integer} id_ativo_destino
   */
  cliente: '/v2/api/client/position/assets/merge',
  profissional: '/v2/api/professional/position/client/assets/merge/', // <int:id_cliente>
}

/**
 * As rotas iniciam por '/v2/api/aawz-partners'
 */
const bi = {
  /**
   * @method GET Listar as empresas.
   */
  empresas: '/v2/api/aawz-partners/pjs',
  /**
   * @method GET Listar quadrantes e configuracao de limite.
   */
  quadrantes: '/v2/api/aawz-partners/auc-quadrant',
  /**
   * @method GET Listar as senioridades do escritorio.
   */
  senioridade: '/v2/api/aawz-partners/seniority',
  /**
   * @method GET Listar os segmetnos do escritorio.
   */
  segmentos: '/v2/api/aawz-partners/segmentation',
  /**
   * @method GET Listar os planos de carreira.
   */
  carreira: '/v2/api/aawz-partners/career-path',
  /**
   * @param {Integer} id Identificador do plano de carreira
   * @method GET Coletar os dados que compoem do plano de carreira.
   */
  carreiraDados: (id) => `/v2/api/aawz-partners/career-path/${id}/data`,
  /**
   * @method GET Coletar os dados de um profissional cadastrado no partners.
   * @param {Array} attributos Lista de atributos para a query.
   * @param {Object} filters Filtros para a query.
   * @param {Object} in Objeto de listas para o filtro.
   * @param {Boolean} with_data Se carrega os dados do profissional.
   *
   * @method POST Adicionar profissional no partners.
   * @param {Object} data Dados do profissional
   *  id_pj:int
   *  id_profissional:int Obrigatorio. Referencia ao profissional na plataforma atual.
   *  codigo_assessor:str
   *  id_plano_carreira:int
   *  id_nivel_carreira:int
   *  id_segmentacao:int
   *  id_senoridade:int
   *  segmentacao_2:str ??
   *  auc:number
   *  auc_potencial:number
   *  roa_medio:number
   *  salario:number
   *  comissionamento:number
   *  id_segmentacao_proposta:int
   *  id_senoridade_proposta:int
   *  id_nivel_carreira_proposto:int
   *  equipe:str
   *  cidade:str
   *  estado:str
   *  tags:array<str>
   *  participacao_societaria:number (imagino que % da pj)
   *  data_inicio_aai:date
   *  data_entrada_escritorio:date
   *  quantidade_clientes:int
   *  data_referencia:date
   *
   * @method PUT Alterar profissional no partners.
   * @param {Object} data Dados do profissional (igual ao post).
   * @param {Object} filters
   * @param {Object} in
   *
   * @method DELETE Remover dados do profissional
   */
  profissionais: '/v2/api/aawz-partners/professionals', // /<id>
  /**
   * @method POST Adicionar ou editar dados de profissionais em lote.
   * @param {Array} data Lista de objetos
   *    id_profissional:int Obrigatorio
   *    id_plano_carreira:int [Opcional]
   *    Ou outros campos para editar [Opcional]
   */
  profissionaisLote: '/v2/api/aawz-partners/professionals/bulk',
  /**
   * @method GET Listar os dados dos clientes.
   * @param {Array} attributes Lista de atributos para a query.
   * @param {Object} filters Dicionario de filtros para a query.
   * @param {Object} in Dicionario de listas
   *
   * @method POST Adicionar um cliente.
   * @param {Object} data Dados do cliente.
   *  id_profissional_responsavel:int
   *  nome_cliente:str
   *  codigo_cliente:str Obrigatorio
   *  codigo_assessor:str
   *  caixa:number
   *  pl:number
   *  pl_potencial:number
   *  roa:number
   *  share_of_wallet:number
   *  id_segmentacao:int
   *  ativo:boolean
   *  origem_profissional:boolean
   *  cidade:str
   *  estado:str
   *  tags:array<str>
   *  data_referencia:date
   *  data_registro:date
   *  data_atualizacao:date
   *
   * @method PUT Editar os dados do cliente.
   * @param {Object} data Dados do cliente (igual ao post).
   * @param {Object} filters
   * @param {Object} in
   *
   * @method DELETE Remover um cliente.
   * @param {Object} filters
   * @param {Object} in
   */
  clientes: '/v2/api/aawz-partners/clients-partners', // /<int:_id>
  /**
   * @method POST Carregar dados gerais de BI
   * @param {Array} attributes
   * @param {Object} filters
   * @param {Object} in
   * @param {Boolean} with_data
   * @param {Array} parts
   *  "auc_grouped_by_segmentation": AuC, # clientes e profissionais para segmentacao
   *  "summary": Dados gerais do BI
   *  "growth_data": Crescimento de auc no ultimo mes
   *  "concentration_data": Dados da concentracao de AuC
   *  "clients_data": dados dos clientes
   *  "professionals_data": dados dos profissionais
   *  "available_parts": Partes disponiveis
   * @param {Array} professionals_ids
   */
  dadosGerais: '/v2/api/aawz-partners/business-intelligence',
  /**
   * @method GET Listar os documentos
   * @param {Array} attributes
   * @param {Object} filters Adicionar filtro para profissional
   * @param {Object} in
   * @param {Boolean} download Se deve baixar o arquivo ou nao. Para baixar precisa do id na rota.
   *
   * @method POST Upload de arquivos
   * @param {Object} data
   *  assinado_por:int
   *  assinado:bool
   *  file_name:str -> Se for vazio, pega o nome do arquivo mesmo.
   *  data_assinatura:datetime
   *  link:str Link externo
   *  is_external_link:bool Se eh um link externo
   * @param {FileStorage} file
   *
   * @method PUT Alterar um arquivo
   * @param {Object} data -> igual ao post.
   * @param {Object} filters
   * @param {Object} in
   * @param {FileStorage} file
   *
   * @method DELETE Remover um arquivo
   */
  documentos: '/v2/api/aawz-partners/partnership/documents', // /<id>
  planilhas: {
    /**
     * PLN01
     * @method GET Baixar os dados historicos dos profissionais ou planilha template.
     * @param {Boolean} template Se baixa o template ou os dados reais.
     * @param {Array} attributes Lista de atributos para a query.
     * @param {Object} filters Objeto com filtros para a query.
     * @param {Object} in Objeto com listas.
     * @param {String} filename
     * @param {String} file_extension Extensao para exportar. Default: excel.
     * @returns Formato base64: {base64:file, name:str, extension:str}
     *
     * @method POST Upload da planilha de profissionais.
     * @param {File} file Excel
     * @param {Object} table Lista de objetos para validar os dados.
     * @param {Boolean} save Se eh pra salvar ja ou apenas validar.
     * @param {String} date Data de referencia do arquivo. D-M-Y
     * @returns
     *  table
     *  Alem do padrao:
     *  _missing_senioridades: senoridades faltantes. Gera erro.
     *  _missing_emails: E-mail de profissional que faltou. Serao adicionados.
     *  _missing_pjs: Empresa que faltou. Serao adicionados.
     *
     * /<id> para editar um dado historico especifico, mesma logica para adicionar.
     */
    profissionais:
      '/v2/api/aawz-partners/import-export/professionals/historical-data',
    /**
     * PLN02
     * @method GET Baixar os dados historicos ou planilha template.
     * @param {Boolean} template Se baixa o template ou os dados reais.
     * @param {Array} attributes Lista de atributos para a query.
     * @param {Object} filters
     * @param {Object} in
     * @param {String} filename
     * @param {String} file_extension
     * @returns Formato base64: {base64:file, name:str, extension:str}
     *
     * @method POST Importar planilha com dados dos clientes.
     * @param {FileStorage} file
     * @param {Object} table
     * @param {Boolean} save
     * @param {String} date %d-%m-%y
     * @returns
     *  table
     *  Alem do padrao:
     *  _missing_professional_codes: Profissionais nao encontrados que devem ser adicionados.
     *  _missing_clients
     *  _added_clients
     *
     * /<id> para editar um dado historico especifico, mesma logica para adicionar.
     */
    clientes:
      '/v2/api/aawz-partners/import-export/clients-partners/historical-data',
  },
  /**
   * @method GET Coletar histórico de importacoes por planilha.
   * @param {String} source [consolidador, aawz-partners] -> por enquanto soh aawz-partners.
   * @param {String} file_name Referencia da planilha.
   */
  planilhasHistorico: '/v2/api/professional/worksheets/uploads/historic',
  /**
   * @method GET Listar
   *
   * @method POST Adicionar/Atualizar
   * @param {Array} data
   *    id_tipo_profissional
   *    id_segmentacao
   *    id_senioridade
   *    anos_de_luvas
   *    bonificacao
   *    carteira
   *    custo_fixo_em_porcentagem_receita
   *    data_atualizacao
   *    data_registro
   *    id
   *    id_escritorio
   *    luvas_por_ano
   *    remuneracao_mensal_minima_garantida *Opcional
   *    roa_liquido
   *    salario_mensal *Opcional
   * @returns {Object} Resposta no formato padrao de validacao de tabelas.
   */
  financeiroUnico:
    '/v2/api/aawz-partners/expansion-plan/config/financial-parameters',
  /**
   * @method GET Listar
   *
   * @method POST Adicionar/Atualizar
   * @param {Array} data Conversao em decimal (base 1, dividir por 100)
   *    conversao_ano_1
   *    conversao_ano_2
   *    conversao_ano_3
   *    conversao_anos_subsequentes
   *    data_atualizacao
   *    data_registro
   *    id
   *    id_escritorio
   *    id_segmentacao
   *    id_senioridade
   *    id_tipo_profissional
   */
  financeiroConversao:
    '/v2/api/aawz-partners/expansion-plan/config/conversion-parameters',
  /**
   * @method GET Listar
   *
   * @method POST Adicionar/Atualizar
   * @param {Array} data Comissao em decimal (base 1, dividir por 100)
   *    comissao_ano_1
   *    comissao_ano_2
   *    comissao_ano_3
   *    comissao_anos_subsequentes
   *    id_segmentacao
   *    id_senioridade
   *    id_tipo_profissional
   */
  financeiroComissao:
    '/v2/api/aawz-partners/expansion-plan/config/comission-parameters',
  parametrosExpansao: {
    /**
     * @method GET Listar. Nao sera populado.
     *
     * @method POST Adicionar/Listar -> enviar somente com valores nao nulos. Garantir soma 100%.
     * @param {Array} data Lista de parametros
     *  {id_segmentacao, participacao}
     */
    segmentacoes: '/v2/api/aawz-partners/expansion-plan/strategy/segmentations',
    /**
     * @method GET Listar
     * @returns
     *    regions: opcoes disponiveis
     *    value: lista com opcoes selecionadas
     *
     * @method POST Adicionar/Atualizar
     * @param {Array} data [{regiao:str}] -> se nao passar, excluir sozinho.
     */
    regioes: '/v2/api/aawz-partners/expansion-plan/strategy/regions',
    /**
     * @method GET Listar itens registrados
     *
     * @method DELETE com /id na rota
     *
     * @method POST Adicionar/Alterar um item
     * @param {Array} data [{data_referencia, id_tipo_profissional, numero_contratacoes}]
     *
     */
    contratacoes: '/v2/api/aawz-partners/expansion-plan/hiring-plan',
    /**
     * @method GET Listar incentivos
     *
     * @method POST Adicionar incentivos da corretora
     * @param {Array} data
     *    valor_anual:int Incentivo em reais no ano.
     *    auc_meta:int Condicao da corretora para receber.
     *    data_referencia:date Ultimo dia do periodo. DD-MM-YYYY
     *
     * @method DELETE com /id no final da rota
     */
    incentivos: '/v2/api/aawz-partners/expansion-plan/brockers-incentive',
    /**
     * @method GET Coletar DRE atual
     *
     * @method POST Adicionar DREs
     * @param {Array} data referente a uma PJ em uma data.
     *    Cada objeto vai ter:
     *      id_pj:int -> se for nulo, eh a holding
     *      entrada:bool -> Se eh receita ou custo.
     *      rubrica:str -> nome da linha do DRE
     *      categoria:str -> apenas para clusterizacao
     *      sub_categoria:str ->
     *      valor:int
     *      data_referencia:str -> ultimo dia do periodo. DD-MM-YYYY
     *
     * @method DELETE Excluir rubricas
     * @param {Integer} _id Na rota. Ex: /office/dre/123
     */
    dre: '/v2/api/aawz-partners/office/dre',
    /**
     * @method GET Listar metas do escritorio
     *
     * @method POST Atualizar metas do escritorio
     * @param {Array} data
     *    auc:float
     *    roa_medio:float Opcional
     *    data_referencia:date DD-MM-YYYY
     *
     * @method DELETE Remover uma meta
     * @param {Integer} id Id na propria rota /id
     */
    metasEscritorio: '/v2/api/aawz-partners/office/auc-goals',
    /**
     * @method GET Listar metas dos profissionais
     * @param {String} grouped_by Metodo de agrupamento. [id_profissional]. Query param
     *
     * @method POST Adicionar/editar metas
     * @param {Array} data Lista de registros
     *    id_profissional:int
     *    auc:float
     *    data_referencia:date DD-MM-YYYY
     *    aprovado:boolean Se o gestor aprovou ela. Opcional
     *
     * @method DELETE Remover metas. Id na rota /id
     */
    metasProfissionais: '/v2/api/aawz-partners/professionals/goals',
    /**
     * Listar custos/receitas profissionais do escritorio.
     *
     * @method GET Listar
     *
     * @method POST Adicionar/editar custos/receitas adicionais.
     * @param {Array} data Lista de objetos
     *    entrada:boolean Se eh receita
     *    rubrica:str Nome da linha
     *    categoria:str Para cluster
     *    sub_categoria:str Para cluster
     *    valor:number
     *    data_referencia:str DD-MM-YYYY (Final do mes/ano)
     *
     * @method DELETE Remover um item
     * @param {Integer} _id Na rota. /_id
     *
     */
    custosAdicionais:
      '/v2/api/aawz-partners/expansion-plan/additional-revenues-costs',
  },
  /**
   * @method PUT Aprovar conjunto de metas de AuC dos profissionais individuais
   * @param {Array} ids Lista de metas
   */
  aprovarMetasProfissionais:
    '/v2/api/aawz-partners/professionals/goals/approve',
  /**
   * @method PUT Desaprovar conjunto de metas de AuC dos profissionais individuais
   * @param {Array} ids Lista de metas
   */
  desaprovarMetasProfissionais:
    '/v2/api/aawz-partners/professionals/goals/disapprove',
  /**
   * @method PUT Enviar email para o profissional solicitando preenchimento das metas
   * @param {Array} ids Lista de profissionais
   */
  enviarSolicitacaoMetas: '/v2/api/aawz-partners/professionals/goals/send',
  /**
   * Projecao de AuC e DRE do escritorio (planejada).
   *
   * @method GET Listar
   */
  projecaoAuC: '/v2/api/aawz-partners/projection/auc-dre',
  /**
   * Historico de evolucao de AuC e captacao (realizado).
   *
   * @method POST Listar
   * @param {Array} professionals_ids Lista dos ids dos profissionais
   */
  historicoAuC: '/v2/api/aawz-partners/business-intelligence/historical-auc',
  /**
   * Gerenciar as contratacoes efetivadas.
   *
   * @method GET Coletar contratacoes.
   * @param {Array} attributes
   * @param {Object} filters
   * @param {Object} in
   *
   * @method POST Adicionar contratacao.
   * @param {Object} data Dados da contratacao
   *    id_tipo_profissional
   *    id_segmentacao
   *    id_senioridade
   *    carteira
   *    roa_liquido
   *    luvas_por_ano
   *    anos_de_luvas
   *    bonificacao
   *    custo_fixo_em_porcentagem_receita
   *    salario_mensal
   *    remuneracao_mensal_minima_garantida
   *    conversao_ano_1
   *    conversao_ano_2
   *    conversao_ano_3
   *    conversao_anos_subsequentes
   *    comissao_ano_1
   *    comissao_ano_2
   *    comissao_ano_3
   *    comissao_anos_subsequentes
   *    data_contratacao
   * @param {Object} dados_profissional Dados do profissional contratado.
   *    login
   *    nome
   *    telefone
   *    codigo_assessor
   * @param {Integer} id_profissional Referencia ao profissional contratado.
   *
   * @method PUT Editar contratacao.
   * @param {Integer} id Parametro na rota. /id
   * @param {Object} data
   *    id_escritorio:int
   *    id_profissional:int
   *    id_tipo_profissional:int
   *    id_segmentacao:int
   *    id_senioridade:int
   *    carteira:int
   *    roa_liquido:float
   *    luvas_por_ano:int
   *    anos_de_luva:int
   *    bonificacao:float
   *    custo_fixo_em_porcentagem_receita:float
   *    salario_mensal:int
   *    remuneracao_mensal_minima_garantida:float
   *    conversao_ano_1
   *    conversao_ano_2
   *    conversao_ano_3
   *    conversao_anos_subsequentes
   *    comissao_ano_1
   *    comissao_ano_2
   *    comissao_ano_3
   *    comissao_anos_subsequentes
   *    data_contratacao:date
   *    data_registro:datetime
   *    data_atualizacao:datetime
   *
   * @method DELETE Remover a contratacao.
   * @param {Integer} id Parametro na rota. /id
   */
  contratacaoRealizada: '/v2/api/aawz-partners/hiring/negotiations-terms',
  /**
   * Parametros adicionais para a parte de partners para o escritorio.
   *
   * @method GET Listar parametros adicionais.
   *
   * @method POST Adicionar parametros.
   * @param {Object} data Objeto com os parametros
   *    horizonte_analise_em_anos:int
   *    ano_inicio_analise:date DD-MM-YYYY
   *    rubrica_valuation:str
   *    multiplo_rubrica_valuation:number
   *    roa_medio:number
   *    caixa_atual:number
   *    receita_12_meses:number
   *    ebitda_12_meses:number
   *    lucro_12_meses:number
   *    custos_fixos_medios:number
   *    custo_variavel_medio:number
   *    porcentagem_custo_fixo_pela_receita:number
   *
   * @method PUT Editar parametros adicionais.
   * @param {Object} data
   * @param {Integer} _id Id na rota. /_id
   */
  parametrosAdicionais: '/v2/api/aawz-partners/office/additional-parameters',
  externAgents: '/v2/api/aawz-partners/external-agent',
  /**
   * Carregar multiplos disponiveis para calculo do valuation.
   */
  multiplos:
    '/v2/api/aawz-partners/office/additional-parameters/valuation-options',
  partnership: {
    professional: '/v2/api/aawz-partners/partnership/professional',
    externAgent: '/v2/api/aawz-partners/partnership/external-agent',
  },
  /**
   * Gerenciar as filias do escritorio
   * @method GET Listar filiais do escritorio
   *
   * @mehtod POST Salvar uma filial
   * @param {Object} data
   * @param {String} data.nome
   * @param {String} data.cidade
   * @param {String} data.estado
   */
  filiais: '/v2/api/aawz-partners/filiais',
  /**
   * Permissões de profissional para filiais (co-líderes)
   * @method GET Listar permissões
   * @method POST Adicionar permissão
   */
  permissoesFilial: '/v2/api/aawz-partners/permissoes-profissional-filial',
  /**
   * @param {Number} id ID da permissão
   * @method DELETE Remover permissão
   */
  permissoesFilialById: (id) => `/v2/api/aawz-partners/permissoes-profissional-filial/${id}`,
  /**
   * @method POST sync co-leaders for a filial in batch
   * @param {Object} data { id_filial: Number, ids_profissionais: Array<Number> }
   */
  permissoesFilialBatch: '/v2/api/aawz-partners/permissoes-profissional-filial/batch',
  projectionAucTeam: '/v2/api/aawz-partners/projection/auc-and-team',
}

const cotizar = {}

const assets = {
  /**
   * @method GET Coletar dados do ativo pelo ISIN ou codigo b3
   * @param {String} isin Codigo B3 ou ISIN do ativo. Query param
   */
  isin: '/v2/api/general/search/bonds',
}

const sendLink = {
  /**
   * Atualizar status do cliente ao copiar link
   * @param {List} ids_clientes
   */
  on_copy: '/v2/api/professional/register_client/copy_link',
  listar_clientes: '/v2/api/professional/partnership/clients/get',
  listar_servicos: '/v2/api/professional/services/offers/get',
}

const movimentacoesPendentes = {
  professional_general:
    '/v2/api/professional/financial-operations/movements/suggestion/list',
  /**
   * @param {Int} id_cliente
   */
  professional_per_client:
    '/v2/api/professional/financial-operations/movements/suggestion/client/list',
  client_general:
    '/v2/api/client/financial-operations/movements/suggestion/list',
  /**
   * Aceitar ativo sugerido
   * @param {List} suggestion_id
   */
  accept_movements:
    '/v2/api/client/financial-operations/movements/suggestion/accept',
  /**
   * Aceitar ativo sugerido
   * @param {List} suggestion_id
   */
  reject_movements:
    '/v2/api/client/financial-operations/movements/suggestion/reject',
}

const suggestImprovement = {
  suggest_improvement: '/api/email_erro',
}

const resgateTotal = {
  resgate_total_contas_automaticas:
    '/v2/api/client/financial-operations/warnings/get', // get
  remover: '/v2/api/client/financial-operations/warning/remove',
  professional: {
    resgate_total_contas_automaticas:
      '/v2/api/professional/financial-operations/warnings/get', // get
    remover: '/v2/api/professional/financial-operations/warning/remove',
  },
}

/* MODAIS */

module.exports = {
  apiBaseUrlOverride,
  baseURL,
  dev,
  navbar,
  zendesk,
  user,
  utils,
  emails,
  tarefasDia,
  parametrizacao,
  dashboard,
  portfolioModelo,
  dashboardIndicadores,
  patrimonio_consolidado,
  minhaCarteira,
  notificacao,
  prospect,
  emailHistorico,
  acessoClientes,
  resumoCliente,
  historicoAtividades,
  evolucaoPatrimonial,
  bi,
  bpo,
  assets,
  profissionais,
  mixProdutos,
  aporte,
  servicos,
  configurarClientes,
  composicaoFundo,
  controleClientes,
  contrato,
  propostas,
  produtos,
  configuracoes,
  importAssets,
  templateEmail,
  historicoAtivo,
  mercadoFundos,
  modeloPDF,
  mercadoAcoes,
  simulador,
  exportar,
  vincularContas,
  vincularAtivos,
  informacoesCadastrais,
  cadastroClientes,
  cadastroServico,
  images,
  gerenciarProfissional,
  pdf,
  ips,
  workspace,
  contratarServico,
  wirecardCliente,
  pagarme,
  cadastroAtivo,
  adicionarTransacao,
  cadastroAporte,
  cadastroProfissional,
  configurarPlanilhas,
  comunicacaoEmail,
  comunicacaoPush,
  atualizar,
  cotizar,
  acoesLoteConsolidador,
  contaInvestimento,
  sendLink,
  movimentacoesPendentes,
  suggestImprovement,
  resgateTotal,
  office,
  assinaturaEmail,
  whatsApp,
  assetAllocation,
  avenueImport,
}
